import { observable } from "mobx";
import {sortCaret} from "../../../comum/components/Icones";
import _ from 'lodash';
import {
    formatarListaDatas,
    formatarListaHoras,
    formatNullableValue,
    montarSelectOption,
    splitBR
} from "../../../../utils/formatar";
import {isInvalidoCodigoContainer, isInvalidoPlacas} from "../../../../utils/validadores";
import moment from "moment";
import React from "react";
import {dadosInvalidos} from "../../../../utils/mensagens";

export default class AgServicosCadastrarStore {
    @observable dadosDoServico;
    @observable listaInvalidos;
    @observable listaComponente;
    @observable edicaoMultipla;

    @observable listaAnexos;
    @observable listaAnexosExcluir;
    @observable isEditar;
    @observable isSetListOn;
    @observable buscandoEditar;
    @observable parametros;
    @observable stringTeste;
    @observable tipoDeAgendamento;
    // Listas de combobox principais
    @observable grupos;
    @observable tipos;
    @observable datas;
    @observable horas;
    @observable ItensEditar;

    // Listas de combobox de form
    @observable bls;
    @observable transportadoras;
    @observable categorias;
    @observable orgaosExpedidores;
    @observable containers;
    @observable notasFiscal;
    @observable containersSetPoint;
    @observable tiposVeiculo;
    @observable CntrSelect;
    @observable clientesEstrangeiros;
    @observable clientesEstrangeirosData;
    @observable ncms;

    // Dados de combobox
    @observable grupoSelecionado;
    @observable valorItemNovo;
    @observable tipoSelecionado;
    @observable dataSelecionada;
    @observable horaSelecionada;
    @observable blSelecionado;
    @observable blNumero;
    @observable blNumeroMsg;
    @observable transportadoraSelecionada;
    @observable categoriaSelecionada;
    @observable orgaoExpedidorSelecionado;
    @observable containerSetPointSelecionado;
    @observable tipoVeiculoSelecionado;
    @observable clienteEstrangeiroSelecionado;
    @observable cobrarDeEstrangeiroSelecionado;
    @observable clienteEstrangeiroSelecionadoData;
    @observable cobrarDeEstrangeiroSelecionadoData;
    @observable containerSelecionado;

    @observable blValido;
    @observable edicaoApenasVeiculo;

    @observable listaMensagens;

    @observable salvo;
    @observable salvar;
    @observable salvando;
    @observable atualiza;
    @observable modalFimAgendamento;
    @observable achouErroAnexos;

    @observable tipoFormAtivo;

    // Referencias de formularios
    @observable parametrosDeCampos;
    refDesovaFreeMapa = { lista: ["DEFRE", "DEMAP"] };
    refDesovaManualAcomp = { lista: ["DEMA", "DEME"] };
    refDesovaCrossDocking = { lista: ["DECMA", "DECME"] };
    refCarregamentoCargaSolta = { lista: ["LEMA", "LEME"] };
    refManuseioImportacao = { lista: ["MDOMA", "MDOME", "MIAN", "MIEX", "MIFOT", "MIIB", "MIMAP", "MIRFB", "MISEG", "EXTCG"] };
    refManuseioImportacaoTwo = { lista: ["EXTRE", "RFCS", "SVCS"] };
    refManuseioExportacao = { lista: ["SVEXP"] };
    refPesagem = { lista: ["PESNO", "PESEM"] };
    refSetPoint = { lista: ["ASP"] };
    refPesagemExportacao = { lista: ["SVPES"] };
    refPesagemImportacao = { lista: ["SVIMP"] };
    referencias = [...this.refDesovaFreeMapa.lista, ...this.refDesovaManualAcomp.lista, ...this.refDesovaCrossDocking.lista
        , ...this.refCarregamentoCargaSolta.lista, ...this.refManuseioImportacao.lista, ...this.refManuseioImportacaoTwo.lista
        , ...this.refManuseioExportacao.lista, ...this.refPesagem.lista, ...this.refSetPoint.lista, ...this.refPesagemExportacao.lista
        , ...this.refPesagemImportacao.lista];
    referenciasIndex = [];

    @observable estadoAlertaPlacas;
    @observable estadoAlertaPlacaCarret1;
    @observable estadoAlertaPlacaCarret2;
    @observable estadoAlertaCliente;
    @observable estadoAlertaCobrarDe;

    @observable buscandoHora;
    @observable loadingBl;
    @observable motoristaBloqueado;

    //Observação de acordo ao grupo e o tipo
    @observable observacaoGrupo;

    // Seleção de containers
    @observable loadingContainers;
    @observable loadingNCMs;
    @observable todosContainersMarcados;
    @observable todosNCMsMarcados;


    //Modais
    @observable temDivergencia;
    @observable exibirModalDivergencia;
    @observable msgModalDivergencia;
    @observable exibirModalDesistenciaVistoria;
    @observable desistenciaMensagem;
    @observable desistencia;

    //Dados do form Motorista
    @observable bloqueiaCategCnh;
    @observable bloqueiaNomeMotorista;
    @observable bloqueiaCpfMotorista;
    @observable bloqueiaIdentidadeMotorista;
    @observable bloqueiaOrgEmissId;

    @observable carregandoTipos;
    constructor(service) {
        this.isEditar = false;
        this.isSetListOn = false;
        this.parametros = false;
        this.blNumero = "";
        this.blNumeroMsg = "";
        this.item = []
        this.ItensEditar = [];
        this.tipoDeAgendamento = [];
        this.listaInvalidos = [];
        this.listaComponente = {};
        let lista = new observable([]);
        _.set(this.listaComponente, `items`, lista);
        // Listas de combobox principais
        this.grupos = false;
        this.tipos = false;
        this.stringTeste = "";
        this.datas = false;
        this.horas = false;
        this.CntrSelect = "";
        this.valorItemNovo = 0;
        // Listas de combobox de form
        this.bls = true;
        this.edicaoMultipla = false;
        this.transportadoras = false;
        this.categorias = false;
        this.orgaosExpedidores = false;
        this.containersSetPoint = false;
        this.tiposVeiculo = false;
        this.clientesEstrangeiros = false;
        this.clientesEstrangeirosData = [];

        this.ncms = false;

        // Dados de combobox
        this.tipoSelecionado = false;
        this.grupoSelecionado = false;
        this.listaMensagens = false;
        this.msgObrigatorio = "Campo obrigatório";
        this.observacaoGrupo = "Se necessário, favor informar referência do processo no campo observação para constar no faturamento.";

        this.salvar = false;
        this.salvando = false;
        this.atualiza = true;
        this.modalFimAgendamento = false;
        this.achouErroAnexos = false;
        this.resultadoFimAgendamento = false;

        //Dados do form Motorista
        this.bloqueiaCategCnh = false;
        this.bloqueiaNomeMotorista = false;
        this.bloqueiaCpfMotorista = false;
        this.bloqueiaIdentidadeMotorista = false;
        this.bloqueiaOrgEmissId = false;

        this.parametrosDeCampos = {};

        this.carregandoTipos = false;

        this.service = service;
        this.limparDados();

        this.referenciasIndex =
        [   { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaFreeMapa, index: this.refDesovaFreeMapa.lista.length }
            , { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaAcompanhada, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length }
            , { funcao: () => this.carregarDesovaCrossdoking(), referenciasCampos: this.service.refCamposDesovaCrossdocking, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length }
            , { funcao: () => this.carregarCarregamentoCargaSolta(), referenciasCampos: this.service.refCamposCarregamentoCargaSolta, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length }
            , { funcao: () => this.carregarDadosManuseioImportacao(), referenciasCampos: this.service.refCamposManuseioImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length }
            , { funcao: () => this.carregarDadosManuseioImportacaoTwo(), referenciasCampos: this.service.refCamposManuseioImportacaoTwo, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length }
            , { funcao: () => this.carregarDadosManuseioExportacao(), referenciasCampos: this.service.refCamposManuseioExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length }
            , { funcao: () => this.carregarPesagem(), referenciasCampos: this.service.refCamposPesagem, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length }
            , { funcao: () => this.carregarSetPoint(), referenciasCampos: this.service.refCamposAjusteSetPoint, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length }
            , { funcao: () => this.carregarPesagemExp(), referenciasCampos: this.service.refCamposPesagemExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length }
            , { funcao: () => this.carregarPesagemImp(), referenciasCampos: this.service.refCamposPesagemImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length + this.refPesagemImportacao.lista.length }
        ];

        
                

        this.tipoFormAtivo = false;

        this.buscandoHora = false;
        this.motoristaBloqueado = true;

        // Agendamentos sem data
        this.semData = [4, 5] // O código 3 tem data quando o tipo for 8 ou 110 e o código 1 tem data quando o tipo for 1, 2, 5, 6, 101, 102
        // Seleção de containers
        this.loadingContainers = false;
        this.loadingNCMs = false;
        this.todosContainersMarcados = false;
        this.todosNCMsMarcados = false;

        //Modais
        this.exibirModalDivergencia = false;
        this.exibirModalDivergencia = false;
        this.msgModalDivergencia = "";
        this.exibirModalDesistenciaVistoria = false;
        this.desistenciaMensagem="";
        this.desistencia=false;

        if (!this.isEditar) this.carregarDadosPrincipais();

        this.SelecAllContainer = 0;
        // TODO Remover
        if (this.referenciaDeTeste)
            this.onChangeTipo(this.referenciaDeTeste);

        this.insereAnexo = this.insereAnexo.bind(this);
        this.removerAnexo = this.removerAnexo.bind(this);
        this.marcarNCM = this.marcarNCM.bind(this);
        this.buscarDadosDoAgendamento = this.buscarDadosDoAgendamento.bind(this);
    };

    setBLNumero = (event) =>
    {
        if (event)
        {
            this.blNumero = event.target.value;
            this.dadosDoServico.AgendServ.NumeroBl = this.blNumero;
        }
    }


    estadoInicialAdicionar = () => {
        this.listaMensagens = false;
        this.isEditar = false;
        this.listaComponente = {};
        let lista = new observable([]);
        _.set(this.listaComponente, `items`, lista);
        this.dadosDoServico = { AgendServ: {}, AgendServMotorista: {}, AgendServItens: [], AgendServItemNotaFiscal: [], AgendServItemMerc: [], AgendServAnexos: null };
        this.valorItemNovo = 0;
        this.listaAnexos = [];
        this.addComponent();
        this.listaComponente.items[0].itemAtivo = true;
    }

    addComponentEditar = () => {
        this.valorItemNovo = this.valorItemNovo + 1;
        if (this.listaComponente) {
            var itemAgendServ =  {
                Id: 0,
                TranspId: this.dadosDoServico.AgendServ.TranspId,
                AgendTipoServId: this.tipoSelecionado.value,
                IndStatus: "",
                DatAgend: this.dadosDoServico.AgendServ.DatAgend,
                HoraAgend: this.dadosDoServico.AgendServ.HoraAgend,
                Cnh: this.dadosDoServico.AgendServMotorista.Cnh,
                PlacaCavalo: this.dadosDoServico.AgendServ.PlacaCavalo,
                PlacaCarret1: this.dadosDoServico.AgendServ.PlacaCarret1,
                PlacaCarret2: this.dadosDoServico.AgendServ.PlacaCarret2,
                MembershipuseridIncl: 0,
                DatIncl: "",
                CdLoc: "",
                DatUsuAlt: "", 
                UsuAlt: null,
                AnaliCritId: null,
                BlId: null,
                NumeroBl: "",
                NumBooking: null,
                ParcIdCobrar: null,
                EstabIdCobrar: null,
                ParcIdDespa: null,
                EstabIdDespa: null,
                FlgComboio: "N",
                EadiId: null,
                DscObs: "",
                IndStatusOsGerad: "",
                DiasFreetime: null,
                IndVeic: "",
                DatFimPrev: "",
                MembershipuseridInclTecon: null,
                MercId: null,
                FlgCancOsNoShow: "",
                EhClienteEstrangeiro: false,
                EhCobrarDeEstrangeiro: false,
                DataHoraAgendFormat: "",
                DesistiuVistoria: false,
                RefTipoServ: "",
                DscTipoServ: "",
                DscGrupo: "",
                CnpjDespa: "",
                CnpjCobrar: "",
                RazaoSocialDespa: "",
                RazaoSocialCobrar: "",
                AgendGroupServ: 0,
            }

      
            var AgendServAnexos = new observable([]);
            var AgendServItemMerc = new observable([]);
            var AgendServItens = new observable([]);

            var novoItem =
            {
                AgendServ: itemAgendServ,
                AgendServAnexos: AgendServAnexos,
                AgendServItemMerc: AgendServItemMerc,
                AgendServItens: AgendServItens,
                AgendServMotorista: this.dadosDoServico.AgendServMotorista,
                UsuarioId: 0,
                ApenasVeiculoMotorista: false,
                UsuarioIdTecon: null,
                cardSelecionado: false,
                tipoSelecionado: this.tipoSelecionado,
                tipoFormAtivo: this.tipoFormAtivo,
                parametrosDeCampos: this.parametrosDeCampos,
                blNumero: "",
                blNumeroMsg: "",
                blSelecionado: false,
                atualiza: true,
                isEditar: false,
                dataSelecionada: this.dataSelecionada,
                horaSelecionada: this.horaSelecionada,
                bls: true,
                blValido: true,
                edicaoApenasVeiculo: false,
                containers: false,
                ncms: false,
                salvo: false,
                msgObrigatorio: "Campo obrigatório",
                loadingContainers: false,
                loadingNCMs: false,
                todosNCMsMarcados: false,
                notasFiscal: false,
                tipos: false,
                containerSetPointSelecionado: false,
                containersSetPoint: false,
                clientesEstrangeiros: false,
                observacaoGrupo: "",
                categoriaSelecionada: this.categoriaSelecionada,
                clientesEstrangeirosData: [],
                clienteEstrangeiroSelecionadoData: [],
                estadoAlertaCobrarDe: false,
                listaMensagens: [],
                listaAnexos: [],
                listaAnexosExcluir: [],
                cobrarDeEstrangeiroSelecionado: false,
                cobrarDeEstrangeiroSelecionadoData: [],
                estadoAlertaCliente: false,
                achouErroAnexos: false,
                indexComProblemas: [],
                clienteEstrangeiroSelecionado: false,
                todosContainersMarcados: false,
                tipoVeiculoSelecionado: this.tipoVeiculoSelecionado,
                transportadoraSelecionada: this.transportadoraSelecionada,
                salvando: false,
                semData: [4, 5],
                tipoDado: "",
                tipoErro: "",
                isInvalido: false,
                mensagemInvalida: "",
                nome: "BL" + this.valorItemNovo,
                referencias: [...this.refDesovaFreeMapa.lista, ...this.refDesovaManualAcomp.lista, ...this.refDesovaCrossDocking.lista
                    , ...this.refCarregamentoCargaSolta.lista, ...this.refManuseioImportacao.lista, ...this.refManuseioImportacaoTwo.lista
                    , ...this.refManuseioExportacao.lista, ...this.refPesagem.lista, ...this.refSetPoint.lista, ...this.refPesagemExportacao.lista
                    , ...this.refPesagemImportacao.lista],
                referenciasIndex:
                [   { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaFreeMapa, index: this.refDesovaFreeMapa.lista.length }
                    , { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaAcompanhada, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length }
                    , { funcao: () => this.carregarDesovaCrossdoking(), referenciasCampos: this.service.refCamposDesovaCrossdocking, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length }
                    , { funcao: () => this.carregarCarregamentoCargaSolta(), referenciasCampos: this.service.refCamposCarregamentoCargaSolta, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length }
                    , { funcao: () => this.carregarDadosManuseioImportacao(), referenciasCampos: this.service.refCamposManuseioImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length }
                    , { funcao: () => this.carregarDadosManuseioImportacaoTwo(), referenciasCampos: this.service.refCamposManuseioImportacaoTwo, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length }
                    , { funcao: () => this.carregarDadosManuseioExportacao(), referenciasCampos: this.service.refCamposManuseioExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length }
                    , { funcao: () => this.carregarPesagem(), referenciasCampos: this.service.refCamposPesagem, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length }
                    , { funcao: () => this.carregarSetPoint(), referenciasCampos: this.service.refCamposAjusteSetPoint, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length }
                    , { funcao: () => this.carregarPesagemExp(), referenciasCampos: this.service.refCamposPesagemExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length }
                    , { funcao: () => this.carregarPesagemImp(), referenciasCampos: this.service.refCamposPesagemImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length + this.refPesagemImportacao.lista.length }
                    ],
                itemAtivo: false,
            }


            this.listaComponente.items.push(novoItem)
        }

        // this.dadosDoServico.listaComponents = this.listaComponente;
    }

    addComponent = () => {
        
        if(this.listaComponente.items.length > 0){
            this.listaComponente.items.map((item, index) => {
                item.itemAtivo = false;
            });
        }

        this.valorItemNovo = this.listaComponente.items.length + 1;

        if (this.listaComponente) {
            var itemAgendServ =  {
                Id: 0,
                TranspId: this.dadosDoServico.AgendServ.TranspId,
                AgendTipoServId: this.tipoSelecionado.value,
                IndStatus: "",
                DatAgend: this.dadosDoServico.AgendServ.DatAgend,
                HoraAgend: this.dadosDoServico.AgendServ.HoraAgend,
                Cnh: this.dadosDoServico.AgendServMotorista.Cnh,
                PlacaCavalo: this.dadosDoServico.AgendServ.PlacaCavalo,
                PlacaCarret1: this.dadosDoServico.AgendServ.PlacaCarret1,
                PlacaCarret2: this.dadosDoServico.AgendServ.PlacaCarret2,
                MembershipuseridIncl: 0,
                DatIncl: "",
                CdLoc: "",
                DatUsuAlt: "", 
                UsuAlt: null,
                AnaliCritId: null,
                BlId: null,
                NumeroBl: "",
                NumBooking: null,
                ParcIdCobrar: null,
                EstabIdCobrar: null,
                ParcIdDespa: null,
                EstabIdDespa: null,
                FlgComboio: "N",
                EadiId: null,
                DscObs: "",
                IndStatusOsGerad: "",
                DiasFreetime: null,
                IndVeic: "",
                DatFimPrev: "",
                MembershipuseridInclTecon: null,
                MercId: null,
                FlgCancOsNoShow: "",
                EhClienteEstrangeiro: false,
                EhCobrarDeEstrangeiro: false,
                DataHoraAgendFormat: "",
                DesistiuVistoria: false,
                RefTipoServ: "",
                DscTipoServ: "",
                DscGrupo: "",
                CnpjDespa: "",
                CnpjCobrar: "",
                RazaoSocialDespa: "",
                RazaoSocialCobrar: "",
                AgendGroupServ: 0,
            }

      
            var AgendServAnexos = new observable([]);
            var AgendServItemMerc = new observable([]);
            var AgendServItens = new observable([]);

            var novoItem =
            {
                AgendServ: itemAgendServ,
                AgendServAnexos: AgendServAnexos,
                AgendServItemMerc: AgendServItemMerc,
                AgendServItens: AgendServItens,
                AgendServMotorista: this.dadosDoServico.AgendServMotorista,
                UsuarioId: 0,
                UsuarioIdTecon: null,
                cardSelecionado: false,
                tipoSelecionado: this.tipoSelecionado,
                tipoFormAtivo: this.tipoFormAtivo,
                parametrosDeCampos: this.parametrosDeCampos,
                blNumero: "",
                blNumeroMsg: "",
                blSelecionado: false,
                atualiza: true,
                isEditar: false,
                dataSelecionada: this.dataSelecionada,
                horaSelecionada: this.horaSelecionada,
                bls: true,
                blValido: true,
                containers: false,
                ncms: false,
                salvo: false,
                msgObrigatorio: "Campo obrigatório",
                loadingContainers: false,
                loadingNCMs: false,
                todosNCMsMarcados: false,
                notasFiscal: false,
                tipos: false,
                containerSetPointSelecionado: false,
                containersSetPoint: false,
                clientesEstrangeiros: false,
                observacaoGrupo: "",
                categoriaSelecionada: this.categoriaSelecionada,
                clientesEstrangeirosData: [],
                clienteEstrangeiroSelecionadoData: [],
                estadoAlertaCobrarDe: false,
                listaMensagens: [],
                listaAnexos: [],
                listaAnexosExcluir: [],
                cobrarDeEstrangeiroSelecionado: false,
                cobrarDeEstrangeiroSelecionadoData: [],
                estadoAlertaCliente: false,
                achouErroAnexos: false,
                indexComProblemas: [],
                clienteEstrangeiroSelecionado: false,
                todosContainersMarcados: false,
                tipoVeiculoSelecionado: this.tipoVeiculoSelecionado,
                transportadoraSelecionada: this.transportadoraSelecionada,
                salvando: false,
                semData: [4, 5],
                tipoDado: "",
                tipoErro: "",
                isInvalido: false,
                mensagemInvalida: "",
                nome: "BL" + this.valorItemNovo,
                referencias: [...this.refDesovaFreeMapa.lista, ...this.refDesovaManualAcomp.lista, ...this.refDesovaCrossDocking.lista
                    , ...this.refCarregamentoCargaSolta.lista, ...this.refManuseioImportacao.lista, ...this.refManuseioImportacaoTwo.lista
                    , ...this.refManuseioExportacao.lista, ...this.refPesagem.lista, ...this.refSetPoint.lista, ...this.refPesagemExportacao.lista
                    , ...this.refPesagemImportacao.lista],
                referenciasIndex:
                [   { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaFreeMapa, index: this.refDesovaFreeMapa.lista.length }
                    , { funcao: () => this.carregarDesovaFree(), referenciasCampos: this.service.refCamposDesovaAcompanhada, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length }
                    , { funcao: () => this.carregarDesovaCrossdoking(), referenciasCampos: this.service.refCamposDesovaCrossdocking, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length }
                    , { funcao: () => this.carregarCarregamentoCargaSolta(), referenciasCampos: this.service.refCamposCarregamentoCargaSolta, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length }
                    , { funcao: () => this.carregarDadosManuseioImportacao(), referenciasCampos: this.service.refCamposManuseioImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length }
                    , { funcao: () => this.carregarDadosManuseioImportacaoTwo(), referenciasCampos: this.service.refCamposManuseioImportacaoTwo, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length }
                    , { funcao: () => this.carregarDadosManuseioExportacao(), referenciasCampos: this.service.refCamposManuseioExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length }
                    , { funcao: () => this.carregarPesagem(), referenciasCampos: this.service.refCamposPesagem, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length }
                    , { funcao: () => this.carregarSetPoint(), referenciasCampos: this.service.refCamposAjusteSetPoint, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length }
                    , { funcao: () => this.carregarPesagemExp(), referenciasCampos: this.service.refCamposPesagemExportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length }
                    , { funcao: () => this.carregarPesagemImp(), referenciasCampos: this.service.refCamposPesagemImportacao, index: this.refDesovaFreeMapa.lista.length + this.refDesovaManualAcomp.lista.length + this.refDesovaCrossDocking.lista.length + this.refCarregamentoCargaSolta.lista.length + this.refManuseioImportacao.lista.length + this.refManuseioImportacaoTwo.lista.length + this.refManuseioExportacao.lista.length + this.refPesagem.lista.length + this.refSetPoint.lista.length + this.refPesagemExportacao.lista.length + this.refPesagemImportacao.lista.length }
                    ],
                itemAtivo: true,
            }


            this.listaComponente.items.push(novoItem)
        }

        // this.dadosDoServico.listaComponents = this.listaComponente;
    }

    fecharModalDivergencia = () => {
        this.exibirModalDivergencia = false;
        this.msgModalDivergencia = "";
    }

    fecharModalDesistenciaVistoria = () => {
        this.exibirModalDesistenciaVistoria = false;
    }

    mostrarModalDesistenciaVistoria = () => {
        this.exibirModalDesistenciaVistoria = true;
    }

    desistirVistoria = async () => {
        try
        {
            const response = await this.service.desistirVistoria(this.dadosDoServico.AgendServ.BlId);
            this.exibirModalDesistenciaVistoria = false;
            this.desistencia =false;
            if (response.data.Sucesso)
            {
                this.desistencia = true;
                this.salvando = true;
                await this.salvarAgendamento();
            } else
            {
                //Mostrar modal com erro na desistencia
                this.desistenciaMensagem = "Erro na desistência.";
            }
        }
        catch(error)
        {
            console.log(error);
        }
    }

    carregarObservacaoGrupo = () =>
    {
        this.observacaoGrupo = "Se necessário, favor informar referência do processo no campo observação para constar no faturamento.";

        if (this.grupoSelecionado && this.grupoSelecionado.label==="REEFER")
        {
            this.observacaoGrupo = "Informar os dados para o ajuste do set point.";
        }
        else if (this.grupoSelecionado && this.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA")
        {
            this.observacaoGrupo = "";
        }
    }

    limparDados = () => {

        setTimeout(function(){
            this.atualiza = false;
        }.bind(this),1);

        this.dadosDoServico = Object.assign({}, this.service.sample);

        this.listaAnexos = [];
        this.listaAnexosExcluir = [];

        this.dataSelecionada = false;
        this.horaSelecionada = false;

        this.horas = false;

        this.containers = false;
        this.notasFiscal = false;
        this.clientesEstrangeiros = false;
        this.clientesEstrangeirosData = [];
        this.ncms = false;

        this.blNumero = "";
        this.blNumeroMsg = "";
        this.blSelecionado = false;
        this.transportadoraSelecionada = false;
        this.categoriaSelecionada = false;
        this.orgaoExpedidorSelecionado = false;
        this.containerSetPointSelecionado = false;
        this.tipoVeiculoSelecionado = false;
        this.clienteEstrangeiroSelecionado = false;
        this.cobrarDeEstrangeiroSelecionado = false;

        this.blValido = true;
        this.edicaoApenasVeiculo = false;
        
        this.temDivergencia = false;

        this.estadoAlertaCliente = false;
        this.estadoAlertaCobrarDe = false;

        this.todosContainersMarcados = false;
        this.todosNCMsMarcados = false;

        this.salvo = false;

        this.bloqueiaCategCnh = false;
        this.bloqueiaNomeMotorista = false;
        this.bloqueiaCpfMotorista = false;
        this.bloqueiaIdentidadeMotorista = false;
        this.bloqueiaOrgEmissId = false;

        setTimeout(function(){
            this.atualiza = true;
        }.bind(this),1);
    };

    carregarDadosPrincipais = (event) => {
        this.service.listarGrupos().then(response => {
            this.grupos = montarSelectOption("Id", "DscGrupo", response.data);
        });

        this.service.listarDatas(event).then(response => {
            this.datas = formatarListaDatas(response.data, "Data");
            if (this.isEditar && this.datas && this.parametrosDeCampos.dataHora) {
                if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") { 
            
                    this.dataSelecionada = this.datas.find(data => data.value.substr(0, 10) === this.listaComponente.items[0].AgendServ.DatAgend.substr(0, 10));
                    if (this.dataSelecionada)
                            this.changeData(this.dataSelecionada);
                }else{
                    this.dataSelecionada = this.datas.find(data => data.value.substr(0, 10) === this.dadosDoServico.AgendServ.DatAgend.substr(0, 10));
                    if (this.dataSelecionada)
                            this.changeData(this.dataSelecionada);
                    }
            }
        });
    };

    // Edição
    iniciaEdicao = (id) => {
        this.buscarDadosDoAgendamento(id);
        this.modalFimAgendamento = false;
    };

    buscarDadosDoAgendamento = (id) => {
        this.buscandoEditar = true;
        this.dadosDoServico = Object.assign({}, this.service.sample);
        this.service.carregarAgendServ(id).then(response => {
            this.dadosDoServico.AgendServ = response.data.AgendServ;
            this.dadosDoServico.AgendServMotorista = response.data.AgendServMotorista;
            this.dadosDoServico.AgendServItens = response.data.AgendServItens;
            this.dadosDoServico.AgendServItemMerc = response.data.AgendServItemMerc;
            this.listaAnexos = Array.from(response.data.AgendServAnexos);
            this.dadosDoServico.UsuarioId = response.data.UsuarioId;
            this.dadosDoServico.ApenasVeiculoMotorista = response.data.ApenasVeiculoMotorista;
            
            this.blNumero = response.data.AgendServ.NumeroBl;
            this.blSelecionado = response.data.AgendServ.BlId;

            this.tipoSelecionado = {value: response.data.AgendServ.AgendTipoServId, label: response.data.AgendServ.DscTipoServ, RefTipoServ: response.data.AgendServ.RefTipoServ} ;

            this.montarNotasFiscaisEdicao();
            this.montarContainersEdicao();
            this.montarNCMsEdicao();

            if (this.blNumero)
                this.montaDadosPorBlEdicao(this.blNumero);

            if(response.data.AgendServ.EhClienteEstrangeiro){
                this.clienteEstrangeiroSelecionado = {value: response.data.AgendServ.ParcIdDespa, label: response.data.AgendServ.RazaoSocialDespa};
                this.clienteEstrangeiroSelecionadoData = response.data.AgendServ.ParcIdDespa + "-" + response.data.AgendServ.EstabIdDespa;
            }

            if(response.data.AgendServ.EhCobrarDeEstrangeiro){
                this.cobrarDeEstrangeiroSelecionado = {value: response.data.AgendServ.ParcIdCobrar, label: response.data.AgendServ.RazaoSocialCobrar};
                this.cobrarDeEstrangeiroSelecionadoData = response.data.AgendServ.ParcIdCobrar + "-" + response.data.AgendServ.EstabIdCobrar;
            }

            this.dadosDoServico.UsuarioIdTecon = response.data.UsuarioIdTecon;
            this.grupoSelecionado = { label: response.data.AgendServ.DscGrupo };

            this.apenasVeiculo(id);

            this.onChangeTipo({value: response.data.AgendServ.AgendTipoServId, label: response.data.AgendServ.DscTipoServ, RefTipoServ: response.data.AgendServ.RefTipoServ}); // TODO Remover
            this.onBlurMotoristaCNH();
        });
    };

    carregarLabelsCombobox = () => {
        // TODO alterar para resultado do serviço
        this.grupoSelecionado = false;
        this.onChangeTipo({value: 1, label: "Tipo que eu inventei", RefTipoServ: "DECMA"}); // TODO Rever
        this.dataSelecionada = false;
        this.horaSelecionada = false;

        this.blSelecionado = false;
        this.transportadoraSelecionada = false;
        this.categoriaSelecionada = false;
        this.orgaoExpedidorSelecionado = false;
        this.containerSetPointSelecionado = false;
        this.tipoVeiculoSelecionado = false;
        this.clienteEstrangeiroSelecionado = false;
        this.cobrarDeEstrangeiroSelecionado = false;
        this.buscandoEditar = true;
    };
    // Fim Edição

    // Carregamento por tipos
    carregarDesovaFree = () => {
        this.carregarBls();
    };

    carregarDesovaCrossdoking = () => {
        this.carregarBls();
        this.carregarTransportadoras();
        this.carregarTiposVeiculos();
        this.carregarCategorias();
        this.carregarOrgaosExpedidores();
    };

    carregarCarregamentoCargaSolta = () => {
        this.carregarBls();
        this.carregarTransportadoras();
        this.carregarTiposVeiculos();
        this.carregarCategorias();
        this.carregarOrgaosExpedidores();
    };

    carregarDadosManuseioImportacao = () => {
        this.carregarBls();
        this.carregarTransportadoras();
        this.carregarCategorias();
        this.carregarOrgaosExpedidores();
    };

    carregarDadosManuseioImportacaoTwo = () => {
        this.carregarBls();
    };

    carregarDadosManuseioExportacao = () => {
        if (!this.isEditar) this.iniciaDadosCntr();
        this.carregarClientesEstrangeiros();
        this.containers = false;
    };

    carregarPesagem = () => {
        if (!this.isEditar) this.iniciaDadosCntr();
        this.carregarBls();
    };

    carregarPesagemImp = () => {
        this.carregarBls();
        this.carregarClientesEstrangeiros();
    };

    carregarPesagemExp = () => {
        this.carregarClientesEstrangeiros();
        if (this.isEditar) this.onBlurBooking();
    };

    carregarSetPoint = () => {
        if (!this.isEditar) this.iniciaDadosCntr();
        this.carregarContainersSetPoint();
    };
    // FIM Carregamento por tipos

    // Busca de dados
    carregarTipos = (grupoServId) => {
        this.carregandoTipos = true;
        this.tipos = [];
        this.onChangeTipo(null);
        this.service.listarTipos(grupoServId).then(response => {
            if (response.data)
                response.data.map(e => this.tipos.push({ value: e.AgendTipoServId, label: e.DscTipoServ, RefTipoServ: e.RefTipoServ }));
        }).catch(err => console.error(err)
        ).finally(() => {this.carregandoTipos = false;});
    };

    carregarBls = () => {
        // if (!this.bls) {
        //     this.loadingBl = true;
        //     this.service.listarBls().then(response => {
        //         this.bls = montarSelectOption("BlId", "NumeroBl", response.data);
        //         this.loadingBl = false;
        //         if (this.isEditar && this.bls) {
        //             this.blSelecionado = this.bls.find(transp => transp.value === this.dadosDoServico.AgendServ.BlId);
        //             if (this.blSelecionado)
        //                 this.montaDadosPorBlEdicao(this.blSelecionado);
        //             else this.listaMensagens = ["O BL desse agendamento não existe"];
        //             //this.montaDadosPorBlEdicao({value:346726.0, label:"HLCURTM181000533"}); // TODO Remover
        //         }
        //     });
        // }
    };

    carregarTransportadoras = () => {
        if (!this.transportadoras)
            this.service.listarTransportadoras().then(response => {
                this.transportadoras = montarSelectOption("TranspId", "ApelidoTransp", response.data);
                if (this.isEditar && this.transportadoras){
                    if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                        this.transportadoraSelecionada = this.transportadoras.find(transp => transp.value === this.listaComponente.items[0].AgendServ.TranspId);
                        this.listaComponente.items.forEach((item) => {
                            item.transportadoraSelecionada = this.transportadoraSelecionada;
                        })

                    } else {
                        this.transportadoraSelecionada = this.transportadoras.find(transp => transp.value === this.dadosDoServico.AgendServ.TranspId);
                    }
                }
            });
    };

    carregarCategorias = () => {
        if (!this.categorias)
            this.service.listarCategorias().then(response => {
                this.categorias = montarSelectOption("Id.RvLowValue", "RvMeaning", response.data);
                if (this.isEditar && this.categorias) {
                    if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                        this.parametrosDeCampos.inputPlaca = false;
                        this.parametrosDeCampos.inputCarreta1 = false;
                        this.parametrosDeCampos.inputCarreta2 = false;
                        this.dadosDoServico.AgendServ.PlacaCavalo = this.listaComponente.items[0].AgendServ.PlacaCavalo != null ? this.listaComponente.items[0].AgendServ.PlacaCavalo : ""
                        this.dadosDoServico.AgendServ.PlacaCarret1 = this.listaComponente.items[0].AgendServ.PlacaCarret1 != null ? this.listaComponente.items[0].AgendServ.PlacaCarret1 : "";
                        this.dadosDoServico.AgendServ.PlacaCarret2 = this.listaComponente.items[0].AgendServ.PlacaCarret2 != null ? this.listaComponente.items[0].AgendServ.PlacaCarret2  : "";

                        this.categoriaSelecionada = this.categorias.find(cat => cat.value === this.listaComponente.items[0].AgendServMotorista.CategCnh);
                        this.parametrosDeCampos.inputPlaca = true;
                        this.parametrosDeCampos.inputCarreta1 = true;
                        this.parametrosDeCampos.inputCarreta2 = true;
                    } else {
                        this.categoriaSelecionada = this.categorias.find(cat => cat.value === this.dadosDoServico.AgendServMotorista.CategCnh);
                    }}
            });
    };

    carregarTiposVeiculos = () => {
        if (!this.tiposVeiculo)
            this.service.listarTipoVeiculos().then(response => {
                this.tiposVeiculo = montarSelectOption("Codigo", "Descr", response.data);
                if (this.isEditar && this.tiposVeiculo){
                    if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                        
                        this.tipoVeiculoSelecionado = this.tiposVeiculo.find(tpVeiculos => tpVeiculos.value === this.listaComponente.items[0].AgendServ.IndVeic);
                        this.listaComponente.items.forEach((item) => {
                            item.tipoVeiculoSelecionado = this.tipoVeiculoSelecionado;
                        })
                    } else {
                        this.tipoVeiculoSelecionado = this.tiposVeiculo.find(tpVeiculos => tpVeiculos.value === this.dadosDoServico.AgendServ.IndVeic);
                    }}
            });
    };

    carregarOrgaosExpedidores = () => {
        if (!this.orgaosExpedidores)
            this.service.listarOrgaosExpedidores().then(response => {
                this.orgaosExpedidores = montarSelectOption("Id", "DscOrgEmis", response.data);
                if (this.isEditar && this.orgaosExpedidores) {
                    if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                       
                        this.orgaoExpedidorSelecionado = this.orgaosExpedidores.find(org => org.value ===  this.listaComponente.items[0].AgendServMotorista.OrgEmissId);
                    } else {
                        this.orgaoExpedidorSelecionado = this.orgaosExpedidores.find(org => org.value === this.dadosDoServico.AgendServMotorista.OrgEmissId);
                    }
                }
            });
    };

    carregarContainersPorBl = (blId) => {
        if (!this.isEditar) this.containers = false;
        this.loadingContainers = true;
        this.service.listarContainersPorBl(blId, this.tipoSelecionado.value).then(response => {
            if(response && response.data) {
                this.loadingContainers = false;
                if (!this.isEditar) {
                    this.containers = [];
                    response.data.map((cntr) => this.containers.push(this.novoContainer(cntr)));
                } else {
                    response.data.map((cntrNovo) => {
                        let achou = this.containers.find(cntr => cntrNovo.CodCntr === cntr.CodCntr);
                        if (!achou) {
                            this.containers.push(this.novoContainer(cntrNovo));
                            this.todosContainersMarcados = false;
                        }
                    });
                }
            }
        });
    };

    novoContainer = (cntr, marcado=false) => {
        return {
            Id: 0,
            AgendServId: 0,
            IndStatus: "",
            UnitId: cntr.HstmvId,
            Volumes: null,
            CodCntr: cntr.CodCntr,
            IndExcluido: "",
            NotasFiscais: [],
            notasContainer: false,
            marcado: marcado,
            Excluir: false,
        }
    };

    carregarNcmPorBl = (blId) => {


    if (!this.isEditar)
        this.ncms = false;

    this.loadingNCMs = true;

    this.service.listarNcmPorBl(blId, this.tipoSelecionado.value).then(response => {
      

        if (response && response.data) {
            this.loadingNCMs = false;

            if (!this.isEditar) {
                this.ncms = [];
                response.data.map(n => this.ncms.push(this.novoNcm(n)));
            } else {
                response.data.map((ncmNovo) => {
                    let achou = this.ncms.find(ncm => ncm.MercId === ncmNovo.Ncm);
                    if (!achou) {
                        this.ncms.push(this.novoNcm(ncmNovo, achou));
                        this.todosNCMsMarcados = false;
                    }
                });
            }
        }
    });
};

    novoNcm = (n, marcado=false) => {
        return {
            Id: 0,
            AgendServItemId: 0,
            MercId: n.Ncm,
            AgendServId: 0,
            marcado: marcado,
            Excluir: false
        }
    };

    carregarItensNotaFiscalPorBl = (NumBl) => {
        this.notasFiscal = [];
        const flagComboio = this.dadosDoServico.AgendServ.FlgComboio==='S';
        this.service.listarNotaFiscalPorBl(NumBl, flagComboio, this.tipoSelecionado.value).then(response => {


            response.data.map(nota => this.notasFiscal.push(
                {
                    value: nota.ProtocoloInfDocId,
                    label: `${nota.NumNota} ${ !flagComboio ? `- Volume  ${nota.Volume}` :""}`,
                    Id: 0,
                    AgendServItemId: (!this.editar) ? 0 : this.dadosDoServico.AgendServ.Id,
                    ProtocoloInfDocId: nota.IdProtocoloInfDoc,
                    NumeroNota: nota.NumNota,
                    QtdVolume: nota.Volume,
                    Excluir: false
                }
            ));
            if (this.isEditar) this.montarNotasFiscaisContainersEdicao();
        });
    };

    carregarContainersSetPoint = () => {
        if (!this.containersSetPoint)
            this.service.listarContainersSetPoint().then(response => {
                this.containersSetPoint = montarSelectOption("Gkey", "Container", response.data);
                if (this.isEditar && this.containersSetPoint && this.dadosDoServico.AgendServItens.length>0)
                    this.containerSetPointSelecionado = this.containersSetPoint.find(org => org.label === this.dadosDoServico.AgendServItens[0].CodCntr);
            });
    };

    carregarClientesEstrangeiros = () => {
        this.service.listarClientesEstrangeiros(this.dadosDoServico.AgendServ.CnpjDespa).then(response => {
            this.clientesEstrangeiros = montarSelectOption("Parcid", "RazaoSocialEmpParcComerc", response.data);
            this.clientesEstrangeirosData = response.data;
        });
    };

    buscarDadosBl = (blId) => {
        this.dadosDoServico.AgendServ.RazaoSocialCobrar = "";
        this.dadosDoServico.AgendServ.CnpjCobrar = "";
        this.dadosDoServico.AgendServ.BlId = "";
        this.service.carregarDadosBl(blId, this.tipoSelecionado.value).then(response => {
            if (response.status ===404)
                this.blNumeroMsg = response.data
            else
                this.blNumeroMsg = "";

            this.dadosDoServico.AgendServ.RazaoSocialCobrar = response.data.RazaoSocialCliente;
            this.dadosDoServico.AgendServ.CnpjCobrar = response.data.CnpjCliente;
            this.dadosDoServico.AgendServ.BlId = response.data.BlId;
            this.parametrosDeCampos.inputMostraCliente = !this.parametrosDeCampos.inputMostraCliente;
            setTimeout(function() {
                this.parametrosDeCampos.inputMostraCliente = !this.parametrosDeCampos.inputMostraCliente;
            }.bind(this), 1)
            
        });
    };

    verificarBl = (blId) => {
        this.blValido = true;
        this.service.validarBl(blId, this.tipoSelecionado.value).then(response => {
            this.blValido = response.data;
        }).catch(error => {
            console.log(error);
        });
    };

    buscarParceiroPorCnpj = () => {
        this.dadosDoServico.AgendServ.RazaoSocialDespa = null;
        this.dadosDoServico.AgendServ.ParcIdDespa = null;
        this.dadosDoServico.AgendServ.EstabIdDespa = null;
        if (this.dadosDoServico.AgendServ.CnpjDespa && this.dadosDoServico.AgendServ.CnpjDespa.length>0) {
            this.service.recuperarParceiroPorCnpj(this.dadosDoServico.AgendServ.CnpjDespa).then(response => {
                if (response.data) {

                    this.dadosDoServico.AgendServ.RazaoSocialDespa = response.data.Razao;
                    this.dadosDoServico.AgendServ.ParcIdDespa = response.data.ParId;
                    this.dadosDoServico.AgendServ.EstabIdDespa = response.data.EstId;
                    this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
                    setTimeout(function() {
                    this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
                    }.bind(this), 1)
                } else {
                    this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
                    setTimeout(function() {
                        this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
                    }.bind(this), 1)
                    this.estadoAlertaCliente = "Cliente não cadastrado";
                }
            }).catch(err => { console.log(err); });
        }else{
            this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
            setTimeout(function() {
                this.parametrosDeCampos.inputMostraRazSocial = !this.parametrosDeCampos.inputMostraRazSocial;
                }.bind(this), 1)
        }

        
    };

    buscarParceiroPorCnpjCobrarDe = () => {
        this.dadosDoServico.AgendServ.RazaoSocialCobrar = null;
        this.dadosDoServico.AgendServ.ParcIdCobrar = null;
        this.dadosDoServico.AgendServ.EstabIdCobrar = null;
        if (this.dadosDoServico.AgendServ.CnpjCobrar && this.dadosDoServico.AgendServ.CnpjCobrar.length>0) {
            this.estadoAlertaCobrarDe = false;
            this.service.recuperarParceiroPorCnpj(this.dadosDoServico.AgendServ.CnpjCobrar).then(response => {
                if (response.data) {
                    
                    this.dadosDoServico.AgendServ.RazaoSocialCobrar = response.data.Razao;
                    this.dadosDoServico.AgendServ.ParcIdCobrar = response.data.ParId;
                    this.dadosDoServico.AgendServ.EstabIdCobrar = response.data.EstId;
                    this.parametrosDeCampos.inputMostraRazSocialCobrarDe = false;
                    setTimeout(function() {
                        this.parametrosDeCampos.inputMostraRazSocialCobrarDe = true;
                    }.bind(this), 1)
                } else {
                    this.parametrosDeCampos.inputMostraRazSocialCobrarDe = false;
                    setTimeout(function() {
                        this.parametrosDeCampos.inputMostraRazSocialCobrarDe = true;
                    }.bind(this), 1)
                    this.estadoAlertaCobrarDe = "Cliente não cadastrado";
                }
            }).catch(err => { console.log(err); });
        }else{
            this.parametrosDeCampos.inputMostraRazSocialCobrarDe = false;
            setTimeout(function() {
                this.parametrosDeCampos.inputMostraRazSocialCobrarDe = true;
            }.bind(this), 1)
        }

        
    };

    buscarHoraPorTipoData = async (data) => {
        try
        {
            this.buscandoHora = true;
            this.horaSelecionada = false;
            this.horas = false;
            let response;

            if(this.edicaoApenasVeiculo){    
                if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") {
                    response = await this.service.listarHoraPorTipoData(this.tipoSelecionado.value, moment(data).format("DD-MM-YYYY"), this.listaComponente.items[0].AgendServ.Id);
                } else {
                    response = await this.service.listarHoraPorTipoData(this.tipoSelecionado.value, moment(data).format("DD-MM-YYYY"), this.dadosDoServico.AgendServ.Id);
                }            
            }else{                
                response = await this.service.listarHoraPorTipoData(this.tipoSelecionado.value, moment(data).format("DD-MM-YYYY"), 0);
            }


            this.horas = await formatarListaHoras(response.data);
            
            this.buscandoHora = false;
            if (this.isEditar && this.horas)
                if (this.grupoSelecionado && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA") { 
                    this.horaSelecionada = await this.horas.find(hora => parseInt(hora.value) === this.listaComponente.items[0].AgendServ.HoraAgend);
                } else {
                    this.horaSelecionada = await this.horas.find(hora => parseInt(hora.value) === this.dadosDoServico.AgendServ.HoraAgend);
                }
        }
        catch(error)
        {
            console.log(error)
        }
    };

    iniciaDadosCntr = () => {
        this.dadosDoServico.AgendServItens = [{
            Id: 0,
            AgendServId: 0,
            IndStatus: "",
            UnitId: 0,
            Volumes: null,
            CodCntr: "",
            IndExcluido: "",
            Excluir: true,
            NotasFiscais: [],
            notasContainer: Array.from(this.notasFiscal),
        }];
    };

    getDadosCntr = (listItemCntr) => {
        if (listItemCntr && listItemCntr.length > 0)
        {
            listItemCntr.map(cntr => {
                this.dadosDoServico.AgendServItens.map((itens , i) => {
                    if (itens.CodCntr === cntr.CodCntr)
                    {
                        this.dadosDoServico.AgendServItens[i].AgendServId = cntr.AgendServId;
                        this.dadosDoServico.AgendServItens[i].UnitId = cntr.UnitId;
                        this.dadosDoServico.AgendServItens[i].CodCntr = cntr.CodCntr;
                        this.dadosDoServico.AgendServItens[i].IndStatus = cntr.IndStatus;
                        this.dadosDoServico.AgendServItens[i].NotasFiscais = cntr.NotasFiscais;
                        this.dadosDoServico.AgendServItens[i].IndExcluido = cntr.IndExcluido;
                        this.dadosDoServico.AgendServItens[i].Volumes = cntr.Volumes;
                    }
                });
            });
        }
    };

    montaDadosPorBlEdicao = (bl) => {
        this.buscarDadosBl(bl);
        this.verificarBl(bl);
        this.carregarContainersPorBl(bl);
        this.carregarNcmPorBl(bl);
        this.carregarItensNotaFiscalPorBl(bl);
    };

    montarContainersEdicao = () => {
        this.todosContainersMarcados = true;
        if (this.dadosDoServico) {
            this.containers = [];
            this.dadosDoServico.AgendServItens.map(cntr => this.containers.push({
                Id: cntr.Id,
                AgendServId: cntr.AgendServId,
                IndStatus: cntr.IndStatus,
                UnitId: cntr.UnitId,
                Volumes: cntr.Volumes,
                CodCntr: cntr.CodCntr,
                IndExcluido: cntr.IndExcluido,
                NotasFiscais: cntr.NotasFiscais,
                notasContainer: false,
                marcado: true,
                Excluir: false,
            }));
        }
    };

    montarNCMsEdicao = () => {
        this.todosNCMsMarcados = true;
        if (this.dadosDoServico) {
            this.ncms = [];
            this.dadosDoServico.AgendServItemMerc.map(ncm => this.ncms.push({
                AgendServId: ncm.AgendServId,
                AgendServItemId: ncm.AgendServItemId,
                Excluir: false,
                Id: ncm.Id,
                MercId: ncm.MercId.toString(),
                marcado: true
            }));
        }
    };

    montarNotasFiscaisEdicao = () => {
        if (this.dadosDoServico)
            this.dadosDoServico.AgendServItens.map(cntr => {
                if (cntr.NotasFiscais)
                    cntr.NotasFiscais.map(nota => {
                        nota.value = nota.ProtocoloInfDocId;
                        nota.label = `${nota.NumeroNota} ${!this.dadosDoServico.AgendServ.FlgComboio==="S" ? `- Volume ${nota.QtdVolume}`: ""}`;
                    });
            });
    };

    montarNotasFiscaisContainersEdicao = () => {
        if (this.dadosDoServico)
            this.containers.map(cntr => {
                cntr.notasContainer = Array.from(this.notasFiscal);
                if (cntr.NotasFiscais)
                    cntr.NotasFiscais.map(nota => {
                        let index = cntr.notasContainer.indexOf(cntr.notasContainer.find(notaCntr => notaCntr.ProtocoloInfDocId === nota.ProtocoloInfDocId));
                        if (index>-1) cntr.notasContainer.splice(index, 1);
                    });
            });
    };
    // FIM Busca de dados

    // Ações
    onChangeGrupo = (event) => {
        if (this.grupoSelecionado !== event) {
            // if(event.label === "CARREGAMENTO DE CARGA SOLTA")
            // {
            //     this.setListaComponent();
            // }
            this.grupoSelecionado = event;
            this.carregarObservacaoGrupo();
            this.carregarTipos(event.value);
        }
    };

    onChangeTipo = (event) => {
        if (this.tipoSelecionado !== event) {
            if (!this.isEditar) {
                this.limparDados();
            }
            this.tipoSelecionado = false;
            this.tipoFormAtivo = false;
            this.parametrosDeCampos = {};
            if (event) {
                this.tipoSelecionado = event;
                this.dadosDoServico.AgendServ.AgendTipoServId = event.value;
                console.log('tipovalue',event.value)
                this.carregarDadosPrincipais(event.value)
                this.parametrosDeCampos = {};

                this.tipoFormAtivo = false;
                let indexSelecionado = this.referencias.indexOf(this.tipoSelecionado.RefTipoServ);
                let x = 0;
                if (indexSelecionado > -1)
                    while (!this.tipoFormAtivo) {
                        if (indexSelecionado < this.referenciasIndex[x].index) {
                            this.tipoFormAtivo = true;
                            this.referenciasIndex[x].funcao();
                            if (this.isEditar)
                                //this.carregarDadosPrincipais(event.value);

                            //Nos casos de Manuseio de Importacao
                            if (this.grupoSelecionado.value===3)
                            {
                                //Verifica os tipos que exigem data e hora
                                if ([8].includes(this.tipoSelecionado.value))
                                    this.referenciasIndex[x].referenciasCampos.dataHora = true
                                else
                                    this.referenciasIndex[x].referenciasCampos.dataHora = false
                            }

                            //Nos casos de Manuseio de Importacao
                            if (this.grupoSelecionado.value===1)
                            {
                                //Verifica os tipos que exigem data e hora
                                if ([1,2,5,6,101,102].includes(this.tipoSelecionado.value))
                                    this.referenciasIndex[x].referenciasCampos.dataHora = true
                                else
                                    this.referenciasIndex[x].referenciasCampos.dataHora = false
                            }
                            this.parametrosDeCampos = this.referenciasIndex[x].referenciasCampos;
                        }
                        x++;
                    }
                if (!this.isEditar && this.grupoSelecionado.label === "CARREGAMENTO DE CARGA SOLTA" && (this.tipoSelecionado.value === 3 || this.tipoSelecionado.value === 4))
                 {
                    console.log(this.grupoSelecionado)
                    this.estadoInicialAdicionar();
                }
            }
        }
    };

    changeData = (event) => {
        if (event) {
            this.dataSelecionada = event;
            this.dadosDoServico.AgendServ.DatAgend = event.value;
            this.buscarHoraPorTipoData(event.value);
        } else {
            this.dataSelecionada = false;
            this.dadosDoServico.AgendServ.DatAgend = 0;
            this.horas = false;
        }
    };

    changeHora = (event) => {
        if (event) {
            this.horaSelecionada = event;
            this.dadosDoServico.AgendServ.HoraAgend = event.value;
        } else {
            this.horaSelecionada = false;
            this.dadosDoServico.AgendServ.HoraAgend = 0;
        }
    };

    changeBl = (event) => {
        this.dadosDoServico.AgendServItens = [];
        if (event) {
            this.blSelecionado = event;
            this.blNumero = event.value;
            this.dadosDoServico.AgendServ.BlId = event.value;
            this.buscarDadosBl(event.value);
            this.verificarBl(event.value);
            this.carregarContainersPorBl(event.value);
            this.carregarNcmPorBl(event.value);
            this.carregarItensNotaFiscalPorBl(event.label);
        } else {
            this.blSelecionado = false;
            this.dadosDoServico.AgendServ.BlId = 0;
            this.dadosDoServico.AgendServ.RazaoSocialCobrar = "";
            this.dadosDoServico.AgendServ.CnpjCobrar = "";
            this.blValido = true;
            this.containers = false;
            this.ncms = false;
        }
    };

    changeBlNumero = (event) => {
        let valor = event;

        if (event && event.target)
            valor = event.target.value.toUpperCase().replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
        this.dadosDoServico.AgendServItens = [];
        if (valor) {
            this.blSelecionado = valor;
            this.blNumero = valor;
            this.buscarDadosBl(valor);
            this.verificarBl(valor);
            this.carregarContainersPorBl(valor);
            this.carregarNcmPorBl(valor);
            this.carregarItensNotaFiscalPorBl(valor);
        } else {
            this.atualiza = false;
            this.blSelecionado = false;
            this.blNumero = "";
            this.blNumeroMsg = "";
            this.dadosDoServico.AgendServ.RazaoSocialCobrar = "";
            this.dadosDoServico.AgendServ.CnpjCobrar = "";
            this.blValido = true;
            this.containers = false;
            this.ncms = false;
            setTimeout(function() {
                this.atualiza = true;
            }.bind(this), 1)
        }
    };

    changeTransportadora = (event) => {
        if (event) {
            this.transportadoraSelecionada = event;
            this.dadosDoServico.AgendServ.TranspId = event.value;
        } else {
            this.transportadoraSelecionada = false;
            this.dadosDoServico.AgendServ.TranspId = 0;
        }
    };

    changeCategoria = (event) => {
        if (event) {
            this.categoriaSelecionada = event;
            this.dadosDoServico.AgendServMotorista.CategCnh = event.value;
        } else {
            this.categoriaSelecionada = false;
            this.dadosDoServico.AgendServMotorista.CategCnh = 0;
        }
    };

    changeOrgao = (event) => {
        if (event) {
            this.orgaoExpedidorSelecionado = event;
            this.dadosDoServico.AgendServMotorista.OrgEmissId = event.value;
        } else {
            this.orgaoExpedidorSelecionado = false;
            this.dadosDoServico.AgendServMotorista.OrgEmissId = null;
        }
    };

    changeContainerSetPoint = (event, pos=0) => {
        if (event) {
            this.containerSetPointSelecionado = event;
            this.dadosDoServico.AgendServItens[pos].CodCntr = event.label;
        } else {
            this.containerSetPointSelecionado = false;
            this.dadosDoServico.AgendServItens[pos].CodCntr = "";
        }
    };

    changeTipoVeiculo = (event) => {
        if (event) {
            this.tipoVeiculoSelecionado = event;
            this.dadosDoServico.AgendServ.IndVeic = event.value;
        } else {
            this.tipoVeiculoSelecionado = false;
            this.dadosDoServico.AgendServ.IndVeic = 0;
        }
    };

    getParcEstab = (ParcId, ehCliente=false) => {
        if (this.clientesEstrangeirosData && this.clientesEstrangeirosData.length > 0)
        {
            this.clientesEstrangeirosData.map(item => {
                if (item.Parcid === ParcId)
                {
                    if (ehCliente){
                        this.clienteEstrangeiroSelecionadoData = item.ParcEstab;
                        this.dadosDoServico.AgendServ.CnpjDespa = "";
                        this.dadosDoServico.AgendServ.ParcIdDespa = item.Parcid;
                        this.dadosDoServico.AgendServ.EstabIdDespa = item.Estabid;
                    } else {
                        this.cobrarDeEstrangeiroSelecionadoData = item.ParcEstab;
                        this.dadosDoServico.AgendServ.CnpjCobrar = "";
                        this.dadosDoServico.AgendServ.ParcIdCobrar = item.Parcid;
                        this.dadosDoServico.AgendServ.EstabIdCobrar = item.Estabid;
                    }
                    return
                }
            });
        }
    }

    changeClienteEstrangeiro = (event) => {
        if (event) {
            this.clienteEstrangeiroSelecionado = event;
            this.getParcEstab(event.value, true);
        } else {
            this.limparClienteEstrangeiro();
        }
    };

    changeEhClienteEstrangeiro = () => {
        this.dadosDoServico.AgendServ.EhClienteEstrangeiro = !this.dadosDoServico.AgendServ.EhClienteEstrangeiro;
        this.limparClienteEstrangeiro();
    };

    limparClienteEstrangeiro = () => {
        this.clienteEstrangeiroSelecionado = false;
        this.clienteEstrangeiroSelecionadoData = [];
        this.dadosDoServico.AgendServ.RazaoSocialDespa = "";
        this.dadosDoServico.AgendServ.CnpjDespa = "";
        this.dadosDoServico.AgendServ.ParcIdDespa = null;
        this.dadosDoServico.AgendServ.EstabIdDespa = null;
        this.estadoAlertaCliente = false;
    };

    changeCobrarDeEstrangeiro = (event) => {
        if (event) {
            this.cobrarDeEstrangeiroSelecionado = event;
            this.getParcEstab(event.value, false);
        } else {
            this.limparCobrarDeEstrangeiro();
        }
    };

    changeEhCobrarDeEstrangeiro = () => {
        this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro = !this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro;
        this.limparCobrarDeEstrangeiro();
    };

    limparCobrarDeEstrangeiro = () => {
        this.cobrarDeEstrangeiroSelecionado = false;
        this.cobrarDeEstrangeiroSelecionadoData = [];
        this.dadosDoServico.AgendServ.RazaoSocialCobrar = "";
        this.dadosDoServico.AgendServ.CnpjCobrar = "";
        this.dadosDoServico.AgendServ.EstabIdCobrar = null;
        this.dadosDoServico.AgendServ.ParcIdCobrar = null;
        this.estadoAlertaCobrarDe = false;
    };

    onBlurBooking = () => {
        if (!this.isEditar) this.containers = false;
        this.loadingContainers = true;
        if (this.dadosDoServico.AgendServ.NumBooking.length>0) {
            this.service.listarContainersPorBooking(this.dadosDoServico.AgendServ.NumBooking).then(response => {
                this.loadingContainers = false;

                if (!this.isEditar) {
                    this.containers = [];
                    response.data.map((cntr) => this.containers.push(this.novoContainer(cntr)));
                } else {
                    response.data.map((cntrNovo) => {
                        let achou = this.containers.find(cntr => cntrNovo.CodCntr === cntr.CodCntr);
                        if (!achou) {
                            this.containers.push(this.novoContainer(cntrNovo));
                            this.todosContainersMarcados = false;
                        }
                    });
                }
            })
        }
    };

    onBlurMotoristaCNH = () => {
        console.log('onBlurMotoristaCNH');
        this.motoristaBloqueado = true;
        this.atualiza=false;
        const cnh = this.dadosDoServico.AgendServMotorista.Cnh;
        // this.dadosDoServico.AgendServMotorista = Object.assign({}, this.service.sample.AgendServMotorista);
        this.dadosDoServico.AgendServMotorista.CategCnh = "";
        this.dadosDoServico.AgendServMotorista.Cpf = 0;
        this.dadosDoServico.AgendServMotorista.CpfString = "";
        this.dadosDoServico.AgendServMotorista.Identidade = 0;
        this.dadosDoServico.AgendServMotorista.IdentidadeString = "";
        this.dadosDoServico.AgendServMotorista.OrgEmissId = null;
        this.dadosDoServico.AgendServMotorista.Nome = "";
        this.dadosDoServico.AgendServMotorista.Id = 0;
        this.categoriaSelecionada = false;
        this.orgaoExpedidorSelecionado = false;

        this.bloqueiaCategCnh = false;
        this.bloqueiaNomeMotorista = false;
        this.bloqueiaCpfMotorista = false;
        this.bloqueiaIdentidadeMotorista = false;
        this.bloqueiaOrgEmissId = false;

        if (cnh>0) {
            this.atualiza=true;
            this.service.carregarMotoristaPorCnh(cnh).then(response => {
                this.atualiza=false;
                if (response.data) {
                    this.dadosDoServico.AgendServMotorista.CategCnh = response.data.CategCnh;
                    this.dadosDoServico.AgendServMotorista.Cpf = response.data.Cpf;
                    this.dadosDoServico.AgendServMotorista.CpfString = response.data.Cpf;
                    this.dadosDoServico.AgendServMotorista.Identidade = response.data.Identidade;
                    this.dadosDoServico.AgendServMotorista.IdentidadeString = response.data.Identidade;
                    this.dadosDoServico.AgendServMotorista.OrgEmissId = response.data.OrgEmissId;
                    this.dadosDoServico.AgendServMotorista.Nome = response.data.Nome;
                    this.dadosDoServico.AgendServMotorista.Id = response.data.Id;
                    this.categoriaSelecionada = { label: response.data.CategCnh };
                    this.dadosDoServico.AgendServMotorista.Cnh = cnh;
                    this.dadosDoServico.AgendServMotorista.CnhString = cnh.toString();

                    this.bloqueiaCategCnh =             this.dadosDoServico.AgendServMotorista.CategCnh &&
                                                        this.dadosDoServico.AgendServMotorista.CategCnh.length > 0;
                    this.bloqueiaNomeMotorista =        this.dadosDoServico.AgendServMotorista.Nome &&
                                                        this.dadosDoServico.AgendServMotorista.Nome.length > 0;
                    this.bloqueiaCpfMotorista =         this.dadosDoServico.AgendServMotorista.Cpf > 0;
                    this.bloqueiaIdentidadeMotorista =  this.dadosDoServico.AgendServMotorista.Identidade > 0;
                    this.bloqueiaOrgEmissId =           this.dadosDoServico.AgendServMotorista.OrgEmissId > 0 ;

                    if (response.data.OrgEmissId && this.orgaosExpedidores)
                        this.orgaoExpedidorSelecionado = this.orgaosExpedidores.find(org => org.value === response.data.OrgEmissId)
                    } else {
                        this.motoristaBloqueado = false;
                        this.dadosDoServico.AgendServMotorista.Cnh = cnh;
                        this.dadosDoServico.AgendServMotorista.CnhString = cnh.toString();
                    }
                setTimeout(function() {
                    this.atualiza = true;
                }.bind(this), 1)
            })
        } else {
            setTimeout(function() {
                this.atualiza = true;
            }.bind(this), 1)
        }
    };

    insereAnexo = (event) => {
        let arquivos = _.map(event.target.files);
        arquivos.map(arquivo => {
            this.listaAnexos.push({
                fileData: arquivo,
                DscAnexo: arquivo.name.replace(/[^a-zA-Z0-9\.]/g, ""),
                extensao: `${arquivo.name.split(".").pop()}`,
                mensagem: "",
                salvando: false
            });
        });
    };

    removerAnexo = (index) => {
        if (this.listaAnexos && this.listaAnexos[index].Id != null)
        {
            this.listaAnexosExcluir.push(this.listaAnexos[index].Id);
        }

        this.listaAnexos.splice(index, 1);
    };

    reiniciarCadastro = () => {
        this.isEditar = false;
        this.dadosDoServico = {AgendServ:{}, AgendServMotorista:{}, AgendServItens:[], AgendServItemNotaFiscal:[], AgendServItemMerc:[], AgendServAnexos:null };
        this.listaAnexos = [];
        this.onChangeTipo(null);
        this.modalFimAgendamento = false;
    };

    reiniciarCadastroMultiplos = () => {
        this.tipoSelecionado = false;
        this.grupoSelecionado = false;
        this.listaMensagens = false;
        this.isEditar = false;
        this.listaComponente = {};
        let lista = new observable([]);
        _.set(this.listaComponente, `items`, lista);
        this.dadosDoServico = { AgendServ: {}, AgendServMotorista: {}, AgendServItens: [], AgendServItemNotaFiscal: [], AgendServItemMerc: [], AgendServAnexos: null };
        this.valorItemNovo = 0;
        this.listaAnexos = [];
        this.onChangeTipo(null);
        this.modalFimAgendamento = false;

        console.log('item dado', this.listaComponente)
    };

    marcarNCM = (ncm) => {
        ncm.marcado = !ncm.marcado;
        this.dadosDoServico.AgendServItemMerc = this.ncms.filter(i => i.marcado===true);
    };

    marcarTodosNCM = () => {
        this.todosNCMsMarcados = !this.todosNCMsMarcados;
        this.ncms.map(ncm => ncm.marcado = this.todosNCMsMarcados);
        this.dadosDoServico.AgendServItemMerc = this.ncms.filter(ncm => ncm.marcado===this.todosNCMsMarcados);
        console.log(this.dadosDoServico.AgendServItemMerc);
    };
    // FIM Ações

    alertaContainer = () => {
        if (this.salvo && this.dadosDoServico.AgendServItens[0]) {
            if (this.parametrosDeCampos.camposObrigatorios.inputContainer && this.dadosDoServico.AgendServItens[0].CodCntr.length===0)
                return "Campo obrigatório";
            if (this.dadosDoServico.AgendServItens[0].CodCntr.length>0 && isInvalidoCodigoContainer(this.dadosDoServico.AgendServItens[0].CodCntr))
                return "Formato: HHHH1234567";
        }
    };

    alertaNumeroBl = () => {
        if (this.salvo && !this.blNumero)
           return this.msgObrigatorio;

        if (this.blNumeroMsg)
           return this.blNumeroMsg;
    };

    alertaCliente = () => {
        if (this.estadoAlertaCliente) return this.estadoAlertaCliente;
        if (this.salvo && this.parametrosDeCampos.camposObrigatorios.inputCliente && this.dadosDoServico.AgendServ.CnpjDespa && this.dadosDoServico.AgendServ.CnpjDespa.length===0) return "Campo obrigatório";
    };

    alertaCobrarDe = () => {
        if (this.estadoAlertaCobrarDe) return this.estadoAlertaCobrarDe;
        if (this.salvo && this.parametrosDeCampos.camposObrigatorios.inputCobrarDe && this.dadosDoServico.AgendServ.CnpjCobrar && this.dadosDoServico.AgendServ.CnpjCobrar.length===0) return "Campo obrigatório";
    };

    finalizarAgendamento = async () => {
        try
        {
            this.salvo = true;
            this.salvando = true;

            this.listaMensagens = false;

            if (!this.parametrosDeCampos.dadosDoMotorista)
                this.dadosDoServico.AgendServMotorista = null;

            await this.insereContainersNaLista();

            let ehInvalido = await this.invalido();
            if (ehInvalido) {
                if (!this.listaMensagens) this.listaMensagens = [dadosInvalidos]; //, ...ehInvalido];
                this.salvando = false;
            } else {
                let valido = await this.validarDados();
                if (valido)
                {
                    await this.salvarAgendamento();
                }
                else
                {
                    this.salvando = false;
                }
            }
        }
        catch(error)
        {
            console.log(error);
            this.salvando = false;
        }

    };

    insereContainersNaLista = () => {
        if (this.parametrosDeCampos.tabelaSelecionarContainers && this.containers)
            this.dadosDoServico.AgendServItens = this.containers.filter(i => i.marcado===true);
    };

    salvarAgendamento = () => {
        this.dadosDoServico.AgendServAnexos = null;
        this.service.salvar(this.dadosDoServico).then(response => {
            if (response.data)
                if (response.data.Sucesso) {
                    this.resultadoFimAgendamento = response.data;
                    if (this.listaAnexos.length===0 && this.listaAnexosExcluir.length===0)
                    {
                        this.containers = [];
                        this.ncms = [];
                        this.salvando = false;
                        this.modalFimAgendamento = true;
                    } else
                    {
                        this.salvarAnexos();
                        this.excluirAnexos();
                    }
                } else {
                    if (response.data.Mensagem)
                        this.listaMensagens = splitBR(response.data.Mensagem);
                    else
                        this.listaMensagens = splitBR(response.data);
                    this.salvando = false;
                }
            else {
                this.salvando = false;
                this.listaMensagens = response.toString();
            }
        }).catch(err => { console.log(err); this.listaMensagens.push(err); this.salvando = false; });
    };

    salvarAnexos = () => {
        this.achouErroAnexos = false;
        this.indexComProblemas = [];
        Promise.all([
            this.listaAnexos.map((arquivo, x) => {
                if (arquivo && arquivo.fileData !== undefined)
                {
                    arquivo.salvando = true;
                    let data = new FormData();
                    data.append('file', arquivo.fileData);
                    return this.service.salvarAnexo(data, arquivo.DscAnexo, this.resultadoFimAgendamento.AgendServId, arquivo.extensao).then(response => {
                        arquivo.salvando = false;
                        if (response) {
                            if (!response.data.Sucesso) {
                                this.incluiErro(x, response.data.Mensagem);
                            }
                        } else {
                            this.incluiErro(x, "Ocorreu um problema");
                        }
                    }).catch(error => {
                        console.log(error);
                        this.achouErroAnexos = true;
                        this.salvandoAnexos = false;
                    })
                }
            }),
        ]).then(() => {
            this.validacaoAnexo();
        }).catch((error) => { console.log(error); this.salvando = false; });
    };

    excluirAnexos = () => {
        this.achouErroAnexos = false;
        this.indexComProblemas = [];
        Promise.all([
            this.listaAnexosExcluir.map((arquivo, x) => {
                return this.service.excluirAnexo(arquivo).then(response => {
                    if (response) {
                        if (!response.data.Sucesso) {
                            this.incluiErro(x, response.data.Mensagem);
                        }
                    } else {
                        this.incluiErro(x, "Ocorreu um problema");
                    }
                }).catch(error => {
                    console.log(error);
                    this.achouErroAnexos = true;
                    this.salvandoAnexos = false;
                })
            }),
        ]).then(() => {
            this.validacaoAnexo();
        }).catch((error) => { console.log(error); this.salvando = false; });
    };

    visualizarAnexo = (anexoId) => {
        let anexo = this.service.mostrarAnexo(anexoId);
        window.open(anexo);
    };

    incluiErro = (x, msg) => {
        this.achouErroAnexos = true;
        this.listaAnexos[x].mensagem = msg;
        this.indexComProblemas.push(x);
    };

    validacaoAnexo = () => {
        if (this.listaAnexos.find(s => s.salvando===true)) {
            setTimeout(function() {
                this.validacaoAnexo();
            }.bind(this), 1000);
        } else {
            this.salvando = false;
            if (!this.achouErroAnexos) {
                this.modalFimAgendamento = true;
            } else {
                this.listaMensagens = ["Favor verificar lista de anexos"];
            }
        }
    };

    validarDados = async () => {
        try
        {
            // verifica se é grupo de exportação
            //if (process.env.ssa && this.grupoSelecionado.value===4) -- Aguardando o serviço enviar o campo value na edição
            if (process.env.ssa)
            {
                if (this.grupoSelecionado.label==="MANUSEIO DE EXPORTACAO")
                {
                    if (this.dadosDoServico.AgendServItens[0].CodCntr)
                    {
                        let parcEstabCobrarCliEstrang   = this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro   ? this.cobrarDeEstrangeiroSelecionadoData   : null;
                        let parcEstabClienteEstrang     = this.dadosDoServico.AgendServ.EhClienteEstrangeiro    ? this.clienteEstrangeiroSelecionadoData    : null;
                        let cnpjCobrarParcComerc        = !this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro  ? this.dadosDoServico.AgendServ.CnpjCobrar  : null;
                        let cnpjParcComerc              = !this.dadosDoServico.AgendServ.EhClienteEstrangeiro   ? this.dadosDoServico.AgendServ.CnpjDespa   : null;

                        let response = await this.service.ValidarDadosManuseioExport(this.dadosDoServico.AgendServ,
                                                                this.dadosDoServico.AgendServItens[0].CodCntr,
                                                                this.dadosDoServico.AgendServ.EhClienteEstrangeiro,
                                                                this.dadosDoServico.AgendServ.DesistiuVistoria,
                                                                this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro,
                                                                parcEstabCobrarCliEstrang,
                                                                parcEstabClienteEstrang,
                                                                cnpjCobrarParcComerc,
                                                                cnpjParcComerc);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            this.listaMensagens = response.data.Mensagens;
                            return false;
                        }
                    }
                } else if (this.grupoSelecionado.label==="REEFER")
                {
                    let response = await this.service.ValidarDadosSetPoint(this.dadosDoServico.AgendServ,
                                                                           this.containerSetPointSelecionado.label,
                                                                           this.containerSetPointSelecionado.value,
                                                                           this.dadosDoServico.AgendServ.DscObs);
                    if (response.data.Sucesso)
                    {
                       this.dadosDoServico.AgendServ = response.data.AgendServ;
                        this.getDadosCntr(response.data.ListItem);
                        return true;
                    }
                    else
                    {
                        this.listaMensagens = response.data.Mensagens;
                        return false;
                    }
                }
                 else if (this.grupoSelecionado.label==="MANUSEIO DE IMPORTACAO")
                {
                    if (this.tipoSelecionado && [26,27,28,29,30,31,32,33,34,108,109].includes(this.tipoSelecionado.value))
                    {
                        let response = await this.service.ValidarManuseioSimplesDesovaOva(this.dadosDoServico);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                    else if (this.tipoSelecionado && [24,25,103,106].includes(this.tipoSelecionado.value))
                    {
                        let response = await this.service.ValidarManuseioImportCargaSolta(this.dadosDoServico.AgendServ);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                    else if (this.tipoSelecionado && [8,110].includes(this.tipoSelecionado.value))
                    {
                        let response = await this.service.ValidarDadosExtremContainerAcomp(this.dadosDoServico);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                }
                else if (this.grupoSelecionado.label==="PESAGEM (SOLAS)")
                {
                    let response = await this.service.ValidarDadosPesagemSolas(this.dadosDoServico.AgendServ,
                                                                               this.dadosDoServico.AgendServItens[0].CodCntr);
                    if (response.data.Sucesso)
                    {
                        this.dadosDoServico.AgendServ = response.data.AgendServ;
                        this.getDadosCntr(response.data.ListItem);
                        return true;
                    }
                    else
                    {
                        this.listaMensagens = response.data.Mensagens;
                        return false;
                    }
                }
                else if (this.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA")
                {
                    //Validar o Veiculo
                    const resVeiculo = await this.service.ValidarDadosVeiculo(this.dadosDoServico.AgendServ);
                    if (resVeiculo.data.Sucesso)
                    {
                        //Validar o Motorista
                        const resMotorista = await this.service.ValidarDadosMotorista(this.dadosDoServico.AgendServMotorista);
                        if (resMotorista.data.Sucesso)
                        {
                            //Validar o Grupo
                            let flagComboio = this.dadosDoServico.AgendServ.FlgComboio === "N" ? false : true;
                            let response = await this.service.ValidarDadosServicLevante(this.dadosDoServico, flagComboio);

                            if (response.data.Sucesso)
                            {
                                this.dadosDoServico.AgendServ = response.data.AgendServ;
                                this.getDadosCntr(response.data.ListItem);
                                return true;
                            }
                            else
                            {
                                // Em caso de divergencia, exibir a opção para desistir da vistoria
                                if (response.data.DivergenciaLacre)
                                {
                                    this.msgModalDivergencia = response.data.Mensagens[0];
                                    this.exibirModalDivergencia = true;
                                }
                                else
                                {
                                    this.listaMensagens = response.data.Mensagens;
                                }
                                return false;
                            }
                        }
                        else
                        {
                            this.listaMensagens = resMotorista.data.Mensagens;
                            return false;
                        }
                    }
                    else
                    {
                        this.listaMensagens = resVeiculo.data.Mensagens;
                        return false;
                    }
                } else if (this.grupoSelecionado.label==="DESOVA")
                {
                    if (this.tipoSelecionado && [5, 6, 101, 102].includes(this.tipoSelecionado.value)) // Desova Crossdocking
                    {
                        //Validar o Veiculo
                        const resVeiculo = await this.service.ValidarDadosVeiculo(this.dadosDoServico.AgendServ);
                        if (resVeiculo.data.Sucesso)
                        {
                            //Validar o Motorista
                            const resMotorista = await this.service.ValidarDadosMotorista(this.dadosDoServico.AgendServMotorista);
                            if (resMotorista.data.Sucesso)
                            {
                                //Validar o Grupo
                                let response = await this.service.ValidarDadosDesovaCrossdocking(this.dadosDoServico);

                                if (response.data.Sucesso)
                                {
                                    this.dadosDoServico.AgendServ = response.data.AgendServ;
                                    this.getDadosCntr(response.data.ListItem);
                                    return true;
                                }
                                else
                                {
                                    // Em caso de divergencia, exibir a opção para desistir da vistoria
                                    if (response.data.DivergenciaLacre)
                                    {
                                        this.msgModalDivergencia = response.data.Mensagens[0];
                                        this.exibirModalDivergencia = true;
                                    }
                                    else
                                    {
                                        this.listaMensagens = response.data.Mensagens;
                                    }
                                    return false;
                                }
                            }
                            else
                            {
                                this.listaMensagens = resMotorista.data.Mensagens;
                                return false;
                            }
                        }
                        else
                        {
                            this.listaMensagens = resVeiculo.data.Mensagens;
                            return false;
                        }
                    } else if (this.tipoSelecionado && [7, 46, 47, 48].includes(this.tipoSelecionado.value)) //Desova Free/Mapa
                    {
                        let response = await this.service.ValidarDadosDesovaFreetime(this.dadosDoServico);

                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }
                            return false;
                        }
                    } else if (this.tipoSelecionado && [1, 2].includes(this.tipoSelecionado.value)) //Desova
                    {
                        let response = await this.service.ValidarDadosDesova(this.dadosDoServico);

                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }
                            return false;
                        }
                    }
                }
            }
        }
        catch(error)
        {
            console.log(error);
        }
    }

    invalido = () => {
        if (this.parametrosDeCampos.camposObrigatorios.desistenciaDeVistoria && !this.blValido && !this.dadosDoServico.AgendServ.DesistiuVistoria) {
            this.listaMensagens = [];
            this.listaMensagens.push("Para continuar o agendamento, é necessário desistir da vistoria."); return true;
        }

        let erros = false; // []
        if (!(this.semData.includes(this.grupoSelecionado.value)) && this.parametrosDeCampos.dataHora && this.tipoSelecionado.RefTipoServ!=="SVCS") {
            if (!this.dataSelecionada) return true;
            if (!this.horaSelecionada) return true;
        }

        if (this.parametrosDeCampos.camposObrigatorios.selectBL && !this.blSelecionado) return true;
        if (this.parametrosDeCampos.camposObrigatorios.selectContainer && !this.containerSetPointSelecionado) return true;

        if (this.parametrosDeCampos.camposObrigatorios.inputContainer && this.dadosDoServico.AgendServItens[0].CodCntr!==null && this.dadosDoServico.AgendServItens[0].CodCntr.length===0) { "Campo obrigatório"; return true; };
        if (this.parametrosDeCampos.camposObrigatorios.inputContainer && isInvalidoCodigoContainer(this.dadosDoServico.AgendServItens[0].CodCntr)) { return true; };

        if (!this.dadosDoServico.AgendServ.EhClienteEstrangeiro &&
            this.parametrosDeCampos.camposObrigatorios.inputCliente &&
            this.dadosDoServico.AgendServ.ParcIdDespa===null)
        {
            return true;
        }

        if (!this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro &&
            this.parametrosDeCampos.camposObrigatorios.inputCobrarDe &&
            this.dadosDoServico.AgendServ.ParcIdCobrar===null)
        {
            return true;
        }

        if (this.parametrosDeCampos.camposObrigatorios.inputBooking && (this.dadosDoServico.AgendServ.NumBooking===null || this.dadosDoServico.AgendServ.NumBooking.length===0)) return true;

        if (this.parametrosDeCampos.camposObrigatorios.dadosDaTransportadora) {
            if (!this.transportadoraSelecionada) return true;
            if (!this.tipoVeiculoSelecionado) return true;
            if (this.dadosDoServico.AgendServ.PlacaCavalo!==null && this.dadosDoServico.AgendServ.PlacaCavalo.length===0) return true;
            if (isInvalidoPlacas(this.dadosDoServico.AgendServ.PlacaCavalo)) return true;
            if (this.dadosDoServico.AgendServ.PlacaCarret1!==null && this.dadosDoServico.AgendServ.PlacaCarret1.length===0) return true;

            if (isInvalidoPlacas(this.dadosDoServico.AgendServ.PlacaCarret1)) return true;
            if (this.tipoVeiculoSelecionado.value==='B' && this.dadosDoServico.AgendServ.PlacaCarret2!==null && this.dadosDoServico.AgendServ.PlacaCarret2.length===0) return true;
            if (isInvalidoPlacas(this.dadosDoServico.AgendServ.PlacaCarret2)) return true;
        }

        if (this.parametrosDeCampos.camposObrigatorios.dadosDoMotorista) {
            if (this.dadosDoServico.AgendServMotorista.Cnh!==null && this.dadosDoServico.AgendServMotorista.Cnh.length===0) return true;
            if (!this.categoriaSelecionada) return true;
            if (this.dadosDoServico.AgendServMotorista.Nome!==null && this.dadosDoServico.AgendServMotorista.Nome.length===0) return true;
            if (this.dadosDoServico.AgendServMotorista.Cpf!==null && this.dadosDoServico.AgendServMotorista.Cpf.length===0) return true;
        }

        if (this.parametrosDeCampos.camposObrigatorios.tabelaSelecionarContainers && this.dadosDoServico.AgendServItens.length===0) return true;

        if (this.parametrosDeCampos.camposObrigatorios.dadosDoCntr) {
            for (let x = 0; x < this.dadosDoServico.AgendServItens.length; x++) {
                if (this.parametrosDeCampos.camposObrigatorios.inputVolume && (this.dadosDoServico.AgendServItens[x].Volumes===0 || !this.dadosDoServico.AgendServItens[x].Volumes && this.dadosDoServico.AgendServItens[x].Volumes.length===0))
                    return true;
                if (this.parametrosDeCampos.camposObrigatorios.selectNotas && (!this.dadosDoServico.AgendServItens[x].NotasFiscais || this.dadosDoServico.AgendServItens[x].NotasFiscais.length===0))
                    return true;
            }
        }

        return false;
    };

    // Seleção de container
    marcarContainer = (cntr) => {
        if (!cntr.notasContainer) cntr.notasContainer = Array.from(this.notasFiscal);
        cntr.marcado = !cntr.marcado;

        if (this.todosContainersMarcados && !cntr.marcado) this.todosContainersMarcados = false;
        else if (this.containers.filter(i => i.marcado===false).length===0) this.todosContainersMarcados = true;
    };

    marcarTodosContainer = () => {
        this.todosContainersMarcados = !this.todosContainersMarcados;
        this.containers.map(cntr => cntr.marcado = this.todosContainersMarcados);
    };

    onChangeVolume = (event, index) => {
        this.containers[index].Volumes = event.target.value;
    };

    onChangeNotaFiscalSelecaoContainer = (row, event) => {
        if(event && row) {
            row.NotasFiscais.push(event);
            row.notasContainer.remove(event);
        }
    };

    removeNotaFiscalFromSelecaoContainer = (selecaoContainer, notaFiscal, index) => {
        selecaoContainer.NotasFiscais.splice(index, 1);
        selecaoContainer.notasContainer.push(notaFiscal);
    };
    // FIM Seleção de container

    // dados de tabelas
    colunasNcm = [{
        dataField: "MercId",
        text: "Ncm",
        sort: true,
        sortCaret: sortCaret,
        formatter: formatNullableValue,
        headerAlign: (column, colIndex) => 'left'
    }];


//<------------------------------Consolidado / Multiplos  ----------------------------------->

onChangeTipoMultiplos = (event, pos) => {
    if (this.listaComponente.items[pos].tipoSelecionado !== event) {
        if (!this.isEditar) {
            this.limparDados();
        }
        this.listaComponente.items[pos].tipoSelecionado = false;
        this.listaComponente.items[pos].tipoFormAtivo = false;
        this.listaComponente.items[pos].parametrosDeCampos = {};
        if (event) {
            this.listaComponente.items[pos].tipoSelecionado = event;
            this.listaComponente.items[pos].AgendServ.AgendTipoServId = event.value;
            this.listaComponente.items[pos].parametrosDeCampos = {};

            this.listaComponente.items[pos].tipoFormAtivo = false;
            let indexSelecionado = this.listaComponente.items[pos].referencias.indexOf(this.listaComponente.items[pos].tipoSelecionado.RefTipoServ);
            let x = 0;
            if (indexSelecionado > -1)
                while (!this.listaComponente.items[pos].tipoFormAtivo) {
                    if (indexSelecionado < this.listaComponente.items[pos].referenciasIndex[x].index) {
                        this.listaComponente.items[pos].tipoFormAtivo = true;
                        this.listaComponente.items[pos].referenciasIndex[x].funcao();
                        if (this.isEditar)
                            this.carregarDadosPrincipais();

                        //Nos casos de Manuseio de Importacao
                        if (this.grupoSelecionado.value===3)
                        {
                            //Verifica os tipos que exigem data e hora
                            if ([8].includes(this.listaComponente.items[pos].tipoSelecionado.value))
                            this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos.dataHora = true
                            else
                            this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos.dataHora = false
                        }

                        //Nos casos de Manuseio de Importacao
                        if (this.grupoSelecionado.value===1)
                        {
                            //Verifica os tipos que exigem data e hora
                            if ([1,2,5,6,101,102].includes(this.listaComponente.items[pos].tipoSelecionado.value))
                            this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos.dataHora = true
                            else
                            this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos.dataHora = false
                        }
                        this.listaComponente.items[pos].parametrosDeCampos = this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos;
                        this.parametrosDeCampos = this.listaComponente.items[pos].referenciasIndex[x].referenciasCampos;
                    }
                    x++;
                }
        }
    }
};

setBLNumeroMultiplos = (event, pos, container) =>
{
    if (event)
    {
        container.blNumero = event.target.value;
        container.AgendServ.NumeroBl = container.blNumero;
    }
}

    changeBlNumeroMultiplos = async (event, pos, container) => {
        console.log(typeof event)
    if (event.length > 0 || typeof event === "object") {
        var tipoAtual = "";
        if (container.itemAtivo) {
            let valor = event;

            if (event && event.target)
                valor = event.target.value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');

            container.AgendServItens = [];
            

            if (valor.length > 0) {
                
            
            await this.service.VerificaDadosBlConsolidado(valor).then((response) => {
                if (response.data == "Nconsolidado") {
                    container.tipoDado = "Nconsolidado";
                    tipoAtual = "Nconsolidado";
                } else {

                    container.tipoDado = "consolidado";
                    tipoAtual = "consolidado";
                }

            })
    
            if (this.listaComponente.items) {
                var contagem = this.listaComponente.items.filter((item) => item.tipoDado == "Nconsolidado");
                if (contagem.length > 2 && tipoAtual == "Nconsolidado") {
                    this.listaMensagens = ["Não é possivel adicionar mais de 2 BL's não consolidados"];
                    this.tipoDeAgendamento.pop()
                    this.listaComponente.items.pop()
                    return;
                }
        
                if (valor) {
                    container.blSelecionado = valor;
                    container.blNumero = valor;
                    this.buscarDadosBlMultiplos(valor, pos, container);
                    this.verificarBlMultiplos(valor, pos, container);
                    this.carregarContainersPorBlMultiplos(valor, pos);
                    this.carregarNcmPorBlMultiplos(valor, pos);
                    this.carregarItensNotaFiscalPorBlMultiplos(valor, pos);
                } else {
                    container.atualiza = false;
                    container.blSelecionado = false;
                    container.blNumero = "";
                    container.blNumeroMsg = "";
                    container.AgendServ.RazaoSocialCobrar = "";
                    container.AgendServ.CnpjCobrar = "";
                    container.blValido = true;
                    container.containers = false;
                    container.ncms = false;
                    setTimeout(function () {
                        container.atualiza = true;
                    }.bind(this), 1)
                }
                }
            }  
        }
    }
};

    changeBlNumeroMultiplosComboio = async (event, pos, container) => {
        if (event.length > 0) {
            var tipoAtual = "";
            if (container.itemAtivo) {
                let valor = event;

                if (event && event.target)
                valor = event.target.value.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');

                container.AgendServItens = [];
                console.log('item', event)
                await this.service.VerificaDadosBlConsolidado(event).then((response) => {  
                    if (response.data == "Nconsolidado") {
                        container.tipoDado = "Nconsolidado";
                        tipoAtual = "Nconsolidado";
                    } else {

                        container.tipoDado = "consolidado";
                        tipoAtual = "consolidado";
                    }

                })

        
                if (this.listaComponente.items) {
                    var contagem = this.listaComponente.items.filter((item) => item.tipoDado == "Nconsolidado");
                    if (contagem.length > 2 && tipoAtual == "Nconsolidado") {
                        this.listaMensagens = ["Não é possivel adicionar mais de 2 BL's não consolidados"];
                        this.tipoDeAgendamento.pop()
                        this.listaComponente.items.pop()
                        return;
                    }
            
                    if (valor) {
                        container.blSelecionado = valor;
                        container.blNumero = valor;
                        this.buscarDadosBlMultiplos(valor, pos, container);
                        this.verificarBlMultiplos(valor, pos, container);
                        this.carregarContainersPorBlMultiplos(valor, pos);
                        this.carregarNcmPorBlMultiplos(valor, pos);
                        this.carregarItensNotaFiscalPorBlMultiplos(valor, pos);
                    } else {
                        container.atualiza = false;
                        container.blSelecionado = false;
                        container.blNumero = "";
                        container.blNumeroMsg = "";
                        container.AgendServ.RazaoSocialCobrar = "";
                        container.AgendServ.CnpjCobrar = "";
                        container.blValido = true;
                        container.containers = false;
                        container.ncms = false; 
                        setTimeout(function() {
                            container.atualiza = true;
                        }.bind(this), 1)
                        }
                    }
                    }
        }
    };
    
    
    
    
    buscarDadosBlMultiplos = (blId, pos) => {
        this.listaComponente.items[pos].AgendServ.RazaoSocialCobrar = "";
        this.listaComponente.items[pos].AgendServ.CnpjCobrar = "";
        this.listaComponente.items[pos].AgendServ.BlId = "";
        this.service.CarregarDadosBlMultiplos(blId).then(response => {
            if (response.status ===404)
            this.listaComponente.items[pos].blNumeroMsg = response.data
            else
        
            this.listaComponente.items[pos].blNumeroMsg = "";

            this.listaComponente.items[pos].AgendServ.RazaoSocialCobrar = response.data.RazaoSocialCliente;
            this.stringTeste = response.data.RazaoSocialCliente;
            this.listaComponente.items[pos].AgendServ.CnpjCobrar = response.data.CnpjCliente;
            this.listaComponente.items[pos].AgendServ.BlId = response.data.BlId;
            //Comentario para atualizar arquivo. Sumiu do develop.
        });
    };

    verificarBlMultiplos = (blId, pos, container) => {
        container.blValido = true;
        this.service.validarBlMultiplo(blId,container.tipoSelecionado.value).then(response => {
        container.blValido = response.data;
        }).catch(error => {
            console.log(error);
        });
    };

    apenasVeiculo = (AgendServId) => {
        this.edicaoApenasVeiculo = false;
        this.service.apenasVeiculo(AgendServId).then(response => {
        this.edicaoApenasVeiculo = response.data;
        }).catch(error => {
            console.log(error);
        });
    };

    carregarContainersPorBlMultiplos = (blId, pos) => {
        if (!this.isEditar) this.listaComponente.items[pos].containers = false;
        this.listaComponente.items[pos].loadingContainers = true;
            this.service.ListarContainersPorBlConsolidado(blId).then(response => {
                if(response && response.data) {
                    this.listaComponente.items[pos].loadingContainers = false;
                    if (!this.isEditar) {
                        this.listaComponente.items[pos].containers = [];
                        response.data.map((cntr) => this.listaComponente.items[pos].containers.push(this.novoContainer(cntr)));
                    } else {
                        response.data.map((cntrNovo) => {
                            this.listaComponente.items[pos].containers == false ? this.listaComponente.items[pos].containers = [] : "";
                            let achou = this.listaComponente.items[pos].containers.find(cntr => cntrNovo.CodCntr === cntr.CodCntr);
                            if (!achou) {
                                this.listaComponente.items[pos].containers.push(this.novoContainer(cntrNovo));
                                this.listaComponente.items[pos].todosContainersMarcados = false;
                            }
                        });
                    }
                }
            });
        };

    carregarNcmPorBlMultiplos = (blId, pos) => {
        if (!this.isEditar)
        this.listaComponente.items[pos].ncms = false;
        this.listaComponente.items[pos].loadingNCMs = true;
        this.service.ListarNcmPorBlConsolidado(blId).then(response => { // "Id", "Ncm"
            if (response && response.data) {
                this.listaComponente.items[pos].loadingNCMs = false;
                if (! this.isEditar) {
                    this.listaComponente.items[pos].ncms = [];
                    response.data.map(n =>  this.listaComponente.items[pos].ncms.push(this.novoNcm(n)));
                } else {
                    response.data.map((ncmNovo) => {
                        this.listaComponente.items[pos].ncms == false ? this.listaComponente.items[pos].ncms = [] : "";
                        let achou =  this.listaComponente.items[pos].ncms.find(ncm => ncm.MercId === ncmNovo.Ncm);
                        if (!achou) {
                            this.listaComponente.items[pos].ncms.push(this.novoNcm(ncmNovo, achou));
                            this.listaComponente.items[pos].todosNCMsMarcados = false;
                        }
                    });
                }
            }
        });
    };



    carregarItensNotaFiscalPorBlMultiplos = (NumBl, pos) => {
        this.listaComponente.items[pos].notasFiscal = [];
        const flagComboio = this.listaComponente.items[pos].AgendServ.FlgComboio==='S';
        this.service.ListarNotaFiscalPorBlConsolidado(NumBl, flagComboio).then(response => {
            response.data.map(nota => this.listaComponente.items[pos].notasFiscal.push(
                {
                    value: nota.ProtocoloInfDocId,
                    label: `${nota.NumNota} ${ !flagComboio ? `- Volume  ${nota.Volume}` :""}`,
                    Id: 0,
                    AgendServItemId: (!this.listaComponente.items[pos].editar) ? 0 : this.listaComponente.items[pos].AgendServ.Id,
                    ProtocoloInfDocId: nota.IdProtocoloInfDoc,
                    NumeroNota: nota.NumNota,
                    QtdVolume: nota.Volume,
                    Excluir: false
                }
            ));
            if (this.isEditar) this.montarNotasFiscaisContainersEdicaoMultiplos(pos);
        });
    };


    montarNotasFiscaisContainersEdicaoMultiplos = (pos) => {
        console.log('posicazinho', pos)
        if (this.listaComponente.items[pos])
        this.listaComponente.items[pos].containers == false ? this.listaComponente.items[pos].containers = [] : "";
        this.listaComponente.items[pos].containers.map(cntr => {
                cntr.notasContainer = Array.from(this.listaComponente.items[pos].notasFiscal);
                if (cntr.NotasFiscais)
                    cntr.NotasFiscais.map(nota => {
                        let index = cntr.notasContainer.indexOf(cntr.notasContainer.find(notaCntr => notaCntr.ProtocoloInfDocId === nota.ProtocoloInfDocId));
                        if (index>-1) cntr.notasContainer.splice(index, 1);
                    });
            });
    };

    alertaNumeroBlMultiplos = (pos) => {
        if (this.listaComponente.items[pos].salvo && !this.listaComponente.items[pos].blNumero)
           return this.listaComponente.items[pos].msgObrigatorio;

        if (this.listaComponente.items[pos].blNumeroMsg)
           return this.listaComponente.items[pos].blNumeroMsg;
    };


    alertaContainerMultiplos = (pos) => {
        if (this.listaComponente.items[pos].salvo && this.listaComponente.items[pos].AgendServItens[0]) {
            if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputContainer && this.listaComponente.items[pos].AgendServItens[0].CodCntr.length===0)
                return "Campo obrigatório";
            if (this.listaComponente.items[pos].AgendServItens[0].CodCntr.length>0 && isInvalidoCodigoContainer(this.listaComponente.items[pos].AgendServItens[0].CodCntr))
                return "Formato: HHHH1234567";
        }
    };

    changeContainerSetPointMultiplos = (event, pos=0, positionInitial) => {
        if (event) {
            this.listaComponente.items[positionInitial].containerSetPointSelecionado = event;
            this.listaComponente.items[positionInitial].AgendServItens[pos].CodCntr = event.label;
        } else {
            this.listaComponente.items[positionInitial].containerSetPointSelecionado = false;
            this.listaComponente.items[positionInitial].AgendServItens[pos].CodCntr = "";
        }
    };

    alertaClienteMultiplos = (pos) => {
        if (this.listaComponente.items[pos].estadoAlertaCliente) return this.listaComponente.items[pos].estadoAlertaCliente;
        if (this.listaComponente.items[pos].salvo && this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputCliente && this.listaComponente.items[pos].AgendServ.CnpjDespa && this.listaComponente.items[pos].AgendServ.CnpjDespa.length===0) return "Campo obrigatório";
    };

    changeClienteEstrangeiroMultiplos = (event, pos) => {
        if (event) {
            this.listaComponente.items[pos].clienteEstrangeiroSelecionado = event;
            this.getParcEstabMultiplos(event.value, true, pos);
        } else {
            this.limparClienteEstrangeiroMultiplos(pos);
        }
    };


    getParcEstabMultiplos = (ParcId, ehCliente=false, pos) => {
        if (this.listaComponente.items[pos].clientesEstrangeirosData && this.listaComponente.items[pos].clientesEstrangeirosData.length > 0)
        {
            this.listaComponente.items[pos].clientesEstrangeirosData.map(item => {
                if (item.Parcid === ParcId)
                {
                    if (ehCliente){
                        this.listaComponente.items[pos].clienteEstrangeiroSelecionadoData = item.ParcEstab;
                        this.listaComponente.items[pos].AgendServ.CnpjDespa = "";
                        this.listaComponente.items[pos].AgendServ.ParcIdDespa = item.Parcid;
                        this.listaComponente.items[pos].AgendServ.EstabIdDespa = item.Estabid;
                    } else {
                        this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionadoData = item.ParcEstab;
                        this.listaComponente.items[pos].AgendServ.CnpjCobrar = "";
                        this.listaComponente.items[pos].AgendServ.ParcIdCobrar = item.Parcid;
                        this.listaComponente.items[pos].AgendServ.EstabIdCobrar = item.Estabid;
                    }
                    return
                }
            });
        }
    }

    limparClienteEstrangeiroMultiplos = (pos) => {
        this.listaComponente.items[pos].clienteEstrangeiroSelecionado = false;
        this.listaComponente.items[pos].clienteEstrangeiroSelecionadoData = [];
        this.listaComponente.items[pos].AgendServ.RazaoSocialDespa = "";
        this.listaComponente.items[pos].AgendServ.CnpjDespa = "";
        this.listaComponente.items[pos].AgendServ.ParcIdDespa = null;
        this.listaComponente.items[pos].AgendServ.EstabIdDespa = null;
        this.listaComponente.items[pos].estadoAlertaCliente = false;
    };

    changeEhClienteEstrangeiroMultiplos = (pos) => {
        this.listaComponente.items[pos].AgendServ.EhClienteEstrangeiro = ! this.listaComponente.items[pos].AgendServ.EhClienteEstrangeiro;
        this.limparClienteEstrangeiroMultiplos();
    };

    buscarParceiroPorCnpjMultiplos = (pos) => {
        this.listaComponente.items[pos].AgendServ.RazaoSocialDespa = null;
        this.listaComponente.items[pos].AgendServ.ParcIdDespa = null;
        this.listaComponente.items[pos].AgendServ.EstabIdDespa = null;
        if (this.listaComponente.items[pos].AgendServ.CnpjDespa && this.listaComponente.items[pos].AgendServ.CnpjDespa.length>0) {
            this.service.recuperarParceiroPorCnpj(this.listaComponente.items[pos].AgendServ.CnpjDespa).then(response => {
                if (response.data) {
                    this.listaComponente.items[pos].AgendServ.RazaoSocialDespa = response.data.Razao;
                    this.listaComponente.items[pos].AgendServ.ParcIdDespa = response.data.ParId;
                    this.listaComponente.items[pos].AgendServ.EstabIdDespa = response.data.EstId;
                } else {
                    this.listaComponente.items[pos].estadoAlertaCliente = "Cliente não cadastrado";
                }
            }).catch(err => { console.log(err); });
        }
        this.listaComponente.items[pos].parametrosDeCampos.inputMostraRazSocial = !this.listaComponente.items[pos].parametrosDeCampos.inputMostraRazSocial;
        setTimeout(function() {
            this.listaComponente.items[pos].parametrosDeCampos.inputMostraRazSocial = !this.listaComponente.items[pos].parametrosDeCampos.inputMostraRazSocial;
        }.bind(this), 1)
    };


    changeEhCobrarDeEstrangeiroMultiplos = (pos) => {
        this.listaComponente.items[pos].AgendServ.EhCobrarDeEstrangeiro = ! this.listaComponente.items[pos].AgendServ.EhCobrarDeEstrangeiro;
        this.limparCobrarDeEstrangeiroMultiplos(pos);
    };

    limparCobrarDeEstrangeiroMultiplos = (pos) => {
         this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionado = false;
         this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionadoData = [];
         this.listaComponente.items[pos].AgendServ.RazaoSocialCobrar = "";
         this.listaComponente.items[pos].AgendServ.CnpjCobrar = "";
         this.listaComponente.items[pos].AgendServ.EstabIdCobrar = null;
         this.listaComponente.items[pos].AgendServ.ParcIdCobrar = null;
         this.listaComponente.items[pos].estadoAlertaCobrarDe = false;
    };


    changeCobrarDeEstrangeiroMultiplos = (event, pos) => {
        if (event) {
            this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionado = event;
            this.getParcEstabMultiplos(event.value, false, pos);
        } else {
            this.limparCobrarDeEstrangeiroMultiplos();
        }
    };

    setDadosAgendamento = (campo, event) => {
             let valorCampo = null;

            if (event) {
                if (event.target) {
                    if (event.target.value != "") {
                        if(!valorCampo) _.set( this.listaComponente.items, campo, event.target.value);
                        else _.set(this.dadosAgendamento, campo, valorCampo);
                    }
                    else this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
                } else {
                    _.set(this.dadosAgendamento, campo, event.value);
                }
            } else {
                this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
            }
        };

        alertaCobrarDeMultiplos = (pos) => {
            if (this.listaComponente.items[pos].estadoAlertaCobrarDe) return this.listaComponente.items[pos].estadoAlertaCobrarDe;
            if (this.listaComponente.items[pos].salvo && this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputCobrarDe && this.listaComponente.items[pos].AgendServ.CnpjCobrar && this.listaComponente.items[pos].AgendServ.CnpjCobrar.length===0) return "Campo obrigatório";
        };

    
    marcarContainerMultiplos = (cntr, pos) => {
            if (!cntr.notasContainer) cntr.notasContainer = Array.from(this.listaComponente.items[pos].notasFiscal);
            cntr.marcado = !cntr.marcado;
    
            if (this.listaComponente.items[pos].todosContainersMarcados && !cntr.marcado) this.listaComponente.items[pos].todosContainersMarcados = false;
            else if (this.listaComponente.items[pos].containers.filter(i => i.marcado===false).length===0) this.listaComponente.items[pos].todosContainersMarcados = true;
        };
    
        marcarTodosContainerMultiplos = (pos) => {
            this.listaComponente.items[pos].todosContainersMarcados = !this.listaComponente.items[pos].todosContainersMarcados;
            this.listaComponente.items[pos].containers.map(cntr => cntr.marcado =this.listaComponente.items[pos].todosContainersMarcados);
    };
    
    onChangeVolumeMultiplos = (event, index, pos) => {
        this.listaComponente.items[pos].containers[index].Volumes = event.target.value;
    };


    onChangeNotaFiscalSelecaoContainerMultiplos = (row, event, pos) => {
        if(event && row) {
            row.NotasFiscais.push(event);
            row.notasContainer.remove(event);
        }
    };

    removeNotaFiscalFromSelecaoContainerMultiplos = (selecaoContainer, notaFiscal, index) => {
        selecaoContainer.NotasFiscais.splice(index, 1);
        selecaoContainer.notasContainer.push(notaFiscal);
    };

    marcarTodosNCMMultiplos = (pos) => {
        this.listaComponente.items[pos].todosNCMsMarcados = !this.listaComponente.items[pos].todosNCMsMarcados;
        this.listaComponente.items[pos].ncms.map(ncm => ncm.marcado = this.listaComponente.items[pos].todosNCMsMarcados);
        this.listaComponente.items[pos].AgendServItemMerc = this.listaComponente.items[pos].ncms.filter(ncm => ncm.marcado===this.listaComponente.items[pos].todosNCMsMarcados);
    };

    marcarNCMMultiplos = (ncm, pos) => {
        ncm.marcado = !ncm.marcado;
        this.listaComponente.items[pos].AgendServItemMerc = this.listaComponente.items[pos].ncms.filter(i => i.marcado===true);
    };

    insereAnexoMultiplos = (event, pos) => {
        let arquivos = _.map(event.target.files);
        arquivos.map(arquivo => {
            this.listaComponente.items[pos].listaAnexos.push({
                fileData: arquivo,
                DscAnexo: arquivo.name.replace(/[^a-zA-Z0-9\.]/g, ""),
                extensao: `${arquivo.name.split(".").pop()}`,
                mensagem: "",
                salvando: false
            });
        });
    };

    removerAnexoMultiplos = (index, pos) => {
        if (this.listaComponente.items[pos].listaAnexos && this.listaComponente.items[pos].listaAnexos[index].Id != null)
        {
            this.listaComponente.items[pos].listaAnexosExcluir.push(this.listaComponente.items[pos].listaAnexos[index].Id);
        }

        this.listaComponente.items[pos].listaAnexos.splice(index, 1);
    };

    visualizarAnexoMultiplos = (anexoId, pos) => {
        let anexo = this.service.mostrarAnexo(anexoId);
        window.open(anexo);
    };


    finalizarAgendamentoMultiplos = async () => {
        this.listaMensagens = []
        
        this.listaComponente.items.map((item, index) => { 
            this.salvando = true;
            
        //    this.salvando = true;    
            try
            {
                item.AgendServ.TranspId = this.dadosDoServico.AgendServ.TranspId == undefined ? null : this.dadosDoServico.AgendServ.TranspId;
                item.AgendServ.DatAgend = this.dadosDoServico.AgendServ.DatAgend  == undefined ? null : this.dadosDoServico.AgendServ.DatAgend;
                item.AgendServ.HoraAgend = this.dadosDoServico.AgendServ.HoraAgend  == undefined ? null : this.dadosDoServico.AgendServ.HoraAgend;
                item.AgendServ.Cnh = this.dadosDoServico.AgendServMotorista.Cnh  == undefined ? null : this.dadosDoServico.AgendServMotorista.Cnh;
                item.AgendServ.PlacaCavalo = this.dadosDoServico.AgendServ.PlacaCavalo == undefined ? null : this.dadosDoServico.AgendServ.PlacaCavalo;
                item.AgendServ.PlacaCarret1 = this.dadosDoServico.AgendServ.PlacaCarret1 == undefined ? null : this.dadosDoServico.AgendServ.PlacaCarret1;
                item.AgendServ.PlacaCarret2 = this.dadosDoServico.AgendServ.PlacaCarret2== undefined ? null : this.dadosDoServico.AgendServ.PlacaCarret2;
                item.AgendServ.IndVeic = this.dadosDoServico.AgendServ.IndVeic  == undefined ? null : this.dadosDoServico.AgendServ.IndVeic;
                item.dataSelecionada = this.dataSelecionada  == undefined ? null : this.dataSelecionada;
                item.horaSelecionada = this.horaSelecionada  == undefined ? null : this.horaSelecionada;
                item.transportadoraSelecionada = this.transportadoraSelecionada  == undefined ? null : this.transportadoraSelecionada;
                item.tipoVeiculoSelecionado = this.tipoVeiculoSelecionado  == undefined ? null : this.tipoVeiculoSelecionado;
                item.categoriaSelecionada = this.categoriaSelecionada  == undefined ? null : this.categoriaSelecionada;
                if (this.isEditar) {
                    item.AgendServ.HoraAgend = this.horaSelecionada.value
                    item.AgendServ.TranspId = this.transportadoraSelecionada.value
                    item.parametrosDeCampos = this.parametrosDeCampos
                    item.AgendServ.IndVeic = this.tipoVeiculoSelecionado.value
                }
            
                if (!item.parametrosDeCampos.dadosDoMotorista)
                    item.AgendServMotorista = null;
                
                
                 this.insereContainersNaListaMultiplos(index);
                
                let ehInvalido = this.invalidoMultiplos(index);
                // let ehInvalido = true;
                
                if (ehInvalido) {
                    // if (!item.listaMensagens) item.listaMensagens = [dadosInvalidos]; //, ...ehInvalido];
                    item.tipoErro = "Dados Invalidos"
                    item.isInvalido = true
                    item.mensagemInvalida = "Existem dados inválidos no formulário. Favor verificar o BL: " + item.blNumero + " na Aba " + item.nome
                }
            }
            catch(error)
            {
                console.log(error);
                // item.salvando = false;
                this.salvando = false;  
            }
       })
        
        this.listaMensagens = []
        var contagem = this.listaComponente.items.filter((item) => item.isInvalido == true);
        if (contagem.length > 0) {
            contagem.map((item) => {
                this.listaMensagens.push(item.mensagemInvalida)
            })
            this.listaComponente.items.map((item) => {
               item.isInvalido = false; 
            });
            this.salvando = false;  
            return
        } 

        for (let index = 0; index < this.listaComponente.items.length; index++) {
            await this.validarDadosMultiplos(index);
        }
       
        
        contagem = this.listaComponente.items.filter((item) => item.isInvalido == true);
        if (contagem.length > 0) {
            contagem.map((item) => {
                this.listaMensagens.push(item.mensagemInvalida)
                this.salvando = false; 
            })
            return
        } else {
            this.listaMensagens = false;
            await this.salvarAgendamentoMultiplos();
        }
    };


    insereContainersNaListaMultiplos = (pos) => {
        if (this.listaComponente.items[pos].parametrosDeCampos.tabelaSelecionarContainers && this.listaComponente.items[pos].containers)
        this.listaComponente.items[pos].AgendServItens = this.listaComponente.items[pos].containers.filter(i => i.marcado===true);
    };


    invalidoMultiplos = (pos) => {
        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.desistenciaDeVistoria && !this.listaComponente.items[pos].blValido && !this.listaComponente.items[pos].AgendServ.DesistiuVistoria) {
            this.listaComponente.items[pos].listaMensagens = [];
            this.listaComponente.items[pos].listaMensagens.push("Para continuar o agendamento, é necessário desistir da vistoria."); return true;
        }

        let erros = false; // []
        if (!( this.listaComponente.items[pos].semData.includes(this.grupoSelecionado.value)) &&  this.listaComponente.items[pos].parametrosDeCampos.dataHora && this.tipoSelecionado.RefTipoServ!=="SVCS") {
            if (! this.listaComponente.items[pos].dataSelecionada) return true;
            if (! this.listaComponente.items[pos].horaSelecionada) return true;
        }

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.selectBL && !this.listaComponente.items[pos].blSelecionado) return true;
        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.selectContainer && !this.listaComponente.items[pos].containerSetPointSelecionado) return true;

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputContainer && this.listaComponente.items[pos].AgendServItens[0].CodCntr!==null && this.listaComponente.items[pos].AgendServItens[0].CodCntr.length===0) { "Campo obrigatório"; return true; };
        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputContainer && isInvalidoCodigoContainer(this.listaComponente.items[pos].AgendServItens[0].CodCntr)) { return true; };

        if (!this.listaComponente.items[pos].AgendServ.EhClienteEstrangeiro &&
            this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputCliente &&
            this.listaComponente.items[pos].AgendServ.ParcIdDespa===null)
        {
            return true;
        }

        if (!this.listaComponente.items[pos].AgendServ.EhCobrarDeEstrangeiro &&
            this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputCobrarDe &&
            this.listaComponente.items[pos].AgendServ.ParcIdCobrar===null)
        {
            return true;
        }

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputBooking && (this.listaComponente.items[pos].AgendServ.NumBooking===null || this.listaComponente.items[pos].AgendServ.NumBooking.length===0)) return true;

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.dadosDaTransportadora) {
            if (!this.listaComponente.items[pos].transportadoraSelecionada) return true;
            if (!this.listaComponente.items[pos].tipoVeiculoSelecionado) return true;
            if (this.listaComponente.items[pos].AgendServ.PlacaCavalo!==null && this.listaComponente.items[pos].AgendServ.PlacaCavalo.length===0) return true;
            if (isInvalidoPlacas(this.listaComponente.items[pos].AgendServ.PlacaCavalo)) return true;
            if (this.listaComponente.items[pos].AgendServ.PlacaCarret1!==null && this.listaComponente.items[pos].AgendServ.PlacaCarret1.length===0) return true;

            if (isInvalidoPlacas(this.listaComponente.items[pos].AgendServ.PlacaCarret1)) return true;
            if (this.listaComponente.items[pos].tipoVeiculoSelecionado.value==='B' && this.listaComponente.items[pos].AgendServ.PlacaCarret2!==null && this.listaComponente.items[pos].AgendServ.PlacaCarret2.length===0) return true;
            if (isInvalidoPlacas(this.listaComponente.items[pos].AgendServ.PlacaCarret2)) return true;
        }

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.dadosDoMotorista) {
            if (this.listaComponente.items[pos].AgendServMotorista.Cnh!==null && this.listaComponente.items[pos].AgendServMotorista.Cnh.length===0) return true;
            if (!this.listaComponente.items[pos].categoriaSelecionada) return true;
            if (this.listaComponente.items[pos].AgendServMotorista.Nome!==null && this.listaComponente.items[pos].AgendServMotorista.Nome.length===0) return true;
            if (this.listaComponente.items[pos].AgendServMotorista.Cpf!==null && this.listaComponente.items[pos].AgendServMotorista.Cpf.length===0) return true;
        }

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.tabelaSelecionarContainers && this.listaComponente.items[pos].AgendServItens.length===0) return true;

        if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.dadosDoCntr) {
            for (let x = 0; x < this.listaComponente.items[pos].AgendServItens.length; x++) {
                if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.inputVolume && (this.listaComponente.items[pos].AgendServItens[x].Volumes===0 || !this.listaComponente.items[pos].AgendServItens[x].Volumes && this.listaComponente.items[pos].AgendServItens[x].Volumes.length===0))
                    return true;
                if (this.listaComponente.items[pos].parametrosDeCampos.camposObrigatorios.selectNotas && (!this.listaComponente.items[pos].AgendServItens[x].NotasFiscais || this.listaComponente.items[pos].AgendServItens[x].NotasFiscais.length===0))
                    return true;
            }
        }

        return false;
    };





    validarDadosMultiplos = async (pos) => {
        try
        {
            // verifica se é grupo de exportação
            //if (process.env.ssa && this.grupoSelecionado.value===4) -- Aguardando o serviço enviar o campo value na edição
            if (process.env.ssa)
            {
                if (this.grupoSelecionado.label==="MANUSEIO DE EXPORTACAO")
                {
                    if (this.dadosDoServico.AgendServItens[0].CodCntr)
                    {
                        let parcEstabCobrarCliEstrang   = this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro   ? this.cobrarDeEstrangeiroSelecionadoData   : null;
                        let parcEstabClienteEstrang     = this.dadosDoServico.AgendServ.EhClienteEstrangeiro    ? this.clienteEstrangeiroSelecionadoData    : null;
                        let cnpjCobrarParcComerc        = !this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro  ? this.dadosDoServico.AgendServ.CnpjCobrar  : null;
                        let cnpjParcComerc              = !this.dadosDoServico.AgendServ.EhClienteEstrangeiro   ? this.dadosDoServico.AgendServ.CnpjDespa   : null;

                        let response =  this.service.ValidarDadosManuseioExport(this.dadosDoServico.AgendServ,
                                                                this.dadosDoServico.AgendServItens[0].CodCntr,
                                                                this.dadosDoServico.AgendServ.EhClienteEstrangeiro,
                                                                this.dadosDoServico.AgendServ.DesistiuVistoria,
                                                                this.dadosDoServico.AgendServ.EhCobrarDeEstrangeiro,
                                                                parcEstabCobrarCliEstrang,
                                                                parcEstabClienteEstrang,
                                                                cnpjCobrarParcComerc,
                                                                cnpjParcComerc);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            this.listaMensagens = response.data.Mensagens;
                            return false;
                        }
                    }
                } else if (this.grupoSelecionado.label==="REEFER")
                {
                    let response = this.service.ValidarDadosSetPoint(this.dadosDoServico.AgendServ,
                                                                           this.containerSetPointSelecionado.label,
                                                                           this.containerSetPointSelecionado.value,
                                                                           this.dadosDoServico.AgendServ.DscObs);
                    if (response.data.Sucesso)
                    {
                       this.dadosDoServico.AgendServ = response.data.AgendServ;
                        this.getDadosCntr(response.data.ListItem);
                        return true;
                    }
                    else
                    {
                        this.listaMensagens = response.data.Mensagens;
                        return false;
                    }
                }
                 else if (this.grupoSelecionado.label==="MANUSEIO DE IMPORTACAO")
                {
                    if (this.tipoSelecionado && [26,27,28,29,30,31,32,33,34,108,109].includes(this.tipoSelecionado.value))
                    {
                        let response = this.service.ValidarManuseioSimplesDesovaOva(this.dadosDoServico);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                    else if (this.tipoSelecionado && [24,25,103,106].includes(this.tipoSelecionado.value))
                    {
                        let response = this.service.ValidarManuseioImportCargaSolta(this.dadosDoServico.AgendServ);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                    else if (this.tipoSelecionado && [8,110].includes(this.tipoSelecionado.value))
                    {
                        let response = this.service.ValidarDadosExtremContainerAcomp(this.dadosDoServico);
                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }

                            return false;
                        }
                    }
                }
                else if (this.grupoSelecionado.label==="PESAGEM (SOLAS)")
                {
                    let response = this.service.ValidarDadosPesagemSolas(this.dadosDoServico.AgendServ,
                                                                               this.dadosDoServico.AgendServItens[0].CodCntr);
                    if (response.data.Sucesso)
                    {
                        this.dadosDoServico.AgendServ = response.data.AgendServ;
                        this.getDadosCntr(response.data.ListItem);
                        return true;
                    }
                    else
                    {
                        this.listaMensagens = response.data.Mensagens;
                        return false;
                    }
                }
                else if (this.grupoSelecionado.label==="CARREGAMENTO DE CARGA SOLTA")
                {
                    //Validar o Veiculo
                    const resVeiculo = await this.service.ValidarDadosVeiculo(this.listaComponente.items[pos].AgendServ);
                    if (resVeiculo.data.Sucesso)
                    {
                        if (this.isEditar) {
                            this.listaComponente.items[pos].AgendServMotorista.CnhString = this.listaComponente.items[pos].AgendServMotorista.Cnh.toString()
                            this.listaComponente.items[pos].AgendServMotorista.CpfString = this.listaComponente.items[pos].AgendServMotorista.Cpf.toString()
                        }
                        //Validar o Motorista
                        const resMotorista = await this.service.ValidarDadosMotorista(this.listaComponente.items[pos].AgendServMotorista);
                        if (resMotorista.data.Sucesso)
                        {
                            //Validar o Grupo
                            let flagComboio = this.listaComponente.items[pos].AgendServ.FlgComboio === "N" ? false : true;
                            let agendamento = {
                                AgendServ: this.listaComponente.items[pos].AgendServ,
                                AgendServAnexos: this.listaComponente.items[pos].AgendServAnexos,
                                AgendServItemMerc: this.listaComponente.items[pos].AgendServItemMerc,
                                AgendServItens: this.listaComponente.items[pos].AgendServItens,
                                AgendServMotorista:this.listaComponente.items[pos].AgendServMotorista,
                                UsuarioId: this.listaComponente.items[pos].UsuarioId,
                                UsuarioIdTecon: this.listaComponente.items[pos].UsuarioIdTecon,
                                ApenasVeiculoMotorista: this.listaComponente.items[pos].ApenasVeiculoMotorista,
                            }
                           
                            let response = await this.service.ValidarDadosServicLevante(agendamento, flagComboio);
                            
                            if (response.data.Sucesso)
                            {
                                this.listaComponente.items[pos].AgendServ = response.data.AgendServ;
                                this.getDadosCntrMultiplos(response.data.ListItem, pos);
                                return true;
                            }
                            else
                            {
                                // Em caso de divergencia, exibir a opção para desistir da vistoria
                                if (response.data.DivergenciaLacre)
                                {
                                    // this.msgModalDivergencia = response.data.Mensagens[0];
                                    this.listaComponente.items[pos].salvando = false;
                                    this.listaComponente.items[pos].tipoErro = "DivergenciaLacre"
                                    this.listaComponente.items[pos].isInvalido = true
                                    this.listaComponente.items[pos].mensagemInvalida =  response.data.Mensagens[0]
                                }
                                else
                                {
                                    this.listaComponente.items[pos].salvando = false;
                                    this.listaComponente.items[pos].tipoErro = "Erro"
                                    this.listaComponente.items[pos].isInvalido = true
                                    this.listaComponente.items[pos].mensagemInvalida =  response.data.Mensagens 
                                }
                                return false;
                            }
                        }
                        else
                        {
                            // this.listaMensagens = resMotorista.data.Mensagens;
                            this.listaComponente.items[pos].salvando = false;
                            this.listaComponente.items[pos].tipoErro = "Dados Motorista Invalidos"
                            this.listaComponente.items[pos].isInvalido = true
                            this.listaComponente.items[pos].mensagemInvalida =  resMotorista.data.Mensagens
                            return false;
                        }
                    }
                    else
                    {
                        this.listaComponente.items[pos].salvando = false;
                        this.listaComponente.items[pos].tipoErro = "Dados Veiculo Invalidos"
                        this.listaComponente.items[pos].isInvalido = true
                        this.listaComponente.items[pos].mensagemInvalida =  resVeiculo.data.Mensagens
                        return false;
                    }
                } else if (this.grupoSelecionado.label==="DESOVA")
                {
                    if (this.tipoSelecionado && [5, 6, 101, 102].includes(this.tipoSelecionado.value)) // Desova Crossdocking
                    {
                        //Validar o Veiculo
                        const resVeiculo = this.service.ValidarDadosVeiculo(this.dadosDoServico.AgendServ);
                        if (resVeiculo.data.Sucesso)
                        {
                            //Validar o Motorista
                            const resMotorista = this.service.ValidarDadosMotorista(this.dadosDoServico.AgendServMotorista);
                            if (resMotorista.data.Sucesso)
                            {
                                //Validar o Grupo
                                let response = this.service.ValidarDadosDesovaCrossdocking(this.dadosDoServico);

                                if (response.data.Sucesso)
                                {
                                    this.dadosDoServico.AgendServ = response.data.AgendServ;
                                    this.getDadosCntr(response.data.ListItem);
                                    return true;
                                }
                                else
                                {
                                    // Em caso de divergencia, exibir a opção para desistir da vistoria
                                    if (response.data.DivergenciaLacre)
                                    {
                                        this.msgModalDivergencia = response.data.Mensagens[0];
                                        this.exibirModalDivergencia = true;
                                    }
                                    else
                                    {
                                        this.listaMensagens = response.data.Mensagens;
                                    }
                                    return false;
                                }
                            }
                            else
                            {
                                this.listaMensagens = resMotorista.data.Mensagens;
                                return false;
                            }
                        }
                        else
                        {
                            this.listaMensagens = resVeiculo.data.Mensagens;
                            return false;
                        }
                    } else if (this.tipoSelecionado && [7, 46, 47, 48].includes(this.tipoSelecionado.value)) //Desova Free/Mapa
                    {
                        let response = this.service.ValidarDadosDesovaFreetime(this.dadosDoServico);

                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }
                            return false;
                        }
                    } else if (this.tipoSelecionado && [1, 2].includes(this.tipoSelecionado.value)) //Desova
                    {
                        let response = this.service.ValidarDadosDesova(this.dadosDoServico);

                        if (response.data.Sucesso)
                        {
                            this.dadosDoServico.AgendServ = response.data.AgendServ;
                            this.getDadosCntr(response.data.ListItem);
                            return true;
                        }
                        else
                        {
                            // Em caso de divergencia, exibir a opção para desistir da vistoria
                            if (response.data.DivergenciaLacre)
                            {
                                this.msgModalDivergencia = response.data.Mensagens[0];
                                this.exibirModalDivergencia = true;
                            }
                            else
                            {
                                this.listaMensagens = response.data.Mensagens;
                            }
                            return false;
                        }
                    }
                }
            }
        }
        catch(error)
        {
            console.log(error);
        }
    }


    getDadosCntrMultiplos = (listItemCntr, pos) => {
        if (listItemCntr && listItemCntr.length > 0)
        {
            listItemCntr.map(cntr => {
                this.listaComponente.items[pos].AgendServItens.map((itens , i) => {
                    if (itens.CodCntr === cntr.CodCntr)
                    {
                        this.listaComponente.items[pos].AgendServItens[i].AgendServId = cntr.AgendServId;
                        this.listaComponente.items[pos].AgendServItens[i].UnitId = cntr.UnitId;
                        this.listaComponente.items[pos].AgendServItens[i].CodCntr = cntr.CodCntr;
                        this.listaComponente.items[pos].AgendServItens[i].IndStatus = cntr.IndStatus;
                        this.listaComponente.items[pos].AgendServItens[i].NotasFiscais = cntr.NotasFiscais;
                        this.listaComponente.items[pos].AgendServItens[i].IndExcluido = cntr.IndExcluido;
                        this.listaComponente.items[pos].AgendServItens[i].Volumes = cntr.Volumes;
                    }
                });
            });
        }
    };


    salvarAgendamentoMultiplos = async () => {
        // this.listaComponente.items[].AgendServAnexos = null;

        let agendamento = [];


        this.listaComponente.items.map((container, i) => { 
            let item = {
                AgendServ: container.AgendServ,
                AgendServAnexos: container.AgendServAnexos,
                AgendServItemMerc: container.AgendServItemMerc,
                AgendServItens: container.AgendServItens,
                AgendServMotorista:container.AgendServMotorista,
                UsuarioId: container.UsuarioId,
                ApenasVeiculoMotorista: container.ApenasVeiculoMotorista,
                UsuarioIdTecon: container.UsuarioIdTecon,
            }
            agendamento.push(item);
        })
        await this.service.salvarMultiplos(agendamento).then(response => {
            if (response.data)
                if (response.data.Sucesso) {
                    this.resultadoFimAgendamento = response.data;
                    this.listaComponente.items.map((container, i) => {
                        
                        if (container.listaAnexos.length===0 && container.listaAnexosExcluir.length===0)
                        {
                           container.containers = [];
                           container.ncms = [];
                           container.salvando = false;
                            this.salvando = true;  
                           container.modalFimAgendamento = true;
                        } else
                        {
                            this.salvarAnexosMultiplos(i);
                            this.excluirAnexos(i);
                        }
                    })
                    this.modalFimAgendamento = true;
                } else {
                    if (response.data.Mensagem) {
                        this.listaMensagens = splitBR(response.data.Mensagem);
                    }
                    else
                    {
                        this.listaMensagens = splitBR(response.data);
                        this.salvando = false;
                    }
                }
            else {
                this.salvando = false;
                this.listaMensagens = response.toString();
            }
        }).catch(err =>
        {
            console.log(err); this.listaMensagens.push(err);
            this.salvando = false;
        }).finally(() => {this.salvando = false;});
    };

    salvarAnexosMultiplos = (pos) => {
        this.listaComponente.items[pos].achouErroAnexos = false;
        this.listaComponente.items[pos].indexComProblemas = [];
        Promise.all([
            this.listaComponente.items[pos].listaAnexos.map((arquivo, x) => {
                if (arquivo && arquivo.fileData !== undefined)
                {
                    arquivo.salvando = true;
                    let data = new FormData();
                    data.append('file', arquivo.fileData);
                    return this.service.salvarAnexo(data, arquivo.DscAnexo, this.resultadoFimAgendamento.AgendServId, arquivo.extensao).then(response => {
                        arquivo.salvando = false;
                        if (response) {
                            if (!response.data.Sucesso) {
                                this.incluiErro(x, response.data.Mensagem);
                            }
                        } else {
                            this.incluiErro(x, "Ocorreu um problema");
                        }
                    }).catch(error => {
                        console.log(error);
                        this.listaComponente.items[pos].achouErroAnexos = true;
                        this.listaComponente.items[pos].salvandoAnexos = false;
                    })
                }
            }),
        ]).then(() => {
            this.validacaoAnexoMultiplos(pos);
        }).catch((error) => { console.log(error); this.salvando = false; });
    };

    excluirAnexosMultiplos = (pos) => {
        this.listaComponente.items[pos].achouErroAnexos = false;
        this.listaComponente.items[pos].indexComProblemas = [];
        Promise.all([
            this.listaComponente.items[pos].listaAnexosExcluir.map((arquivo, x) => {
                return this.service.excluirAnexo(arquivo).then(response => {
                    if (response) {
                        if (!response.data.Sucesso) {
                            this.incluiErro(x, response.data.Mensagem);
                        }
                    } else {
                        this.incluiErro(x, "Ocorreu um problema");
                    }
                }).catch(error => {
                    console.log(error);
                    this.listaComponente.items[pos].achouErroAnexos = true;
                    this.listaComponente.items[pos].salvandoAnexos = false;
                })
            }),
        ]).then(() => {
            this.validacaoAnexoMultiplos(pos);
        }).catch((error) => { console.log(error); this.listaComponente.items[pos].salvando = false; });
    };


    validacaoAnexoMultiplos = (pos) => {
        if (this.listaComponente.items[pos].listaAnexos.find(s => s.salvando===true)) {
            setTimeout(function() {
                this.validacaoAnexoMultiplos(pos);
            }.bind(this), 1000);
        } else {
            this.listaComponente.items[pos].salvando = false;
            if (!this.listaComponente.items[pos].achouErroAnexos) {
                this.modalFimAgendamento = true;
            } else {
                this.listaMensagens = ["Favor verificar lista de anexos"];
            }
        }
    };

    iniciaEdicaoMultiplos = async (id, grupo, tipo, placa, hora, dat) => {
        const delay = ms => new Promise(res => setTimeout(res, ms));
        this.edicaoMultipla = true;
        let combo = [];
        await this.service.listarMultiplos(id, grupo, tipo, placa, hora, dat).then(response => { 
            if (response.data.length > 0) {
                this.ItensEditar = response.data;
            }
        })

        if (this.ItensEditar.length > 0) {
            for (let i = 0; i < this.ItensEditar.length; i++) {
                this.addComponent();
                if (this.listaComponente.items.length > 0) {
                       await this.buscarDadosDoAgendamentoMultiplos(this.ItensEditar[i].AgendServId, i);
                }
            }
        }

        this.modalFimAgendamento = false;
        await delay(5000);
        this.edicaoMultipla = false
    };

    buscarDadosDoAgendamentoMultiplos = async (id, pos) => {
            
        this.buscandoEditar = true;
        // this.dadosDoServico = Object.assign({}, this.service.sample);
        await this.service.carregarAgendServ(id).then(response => {
            this.listaComponente.items[pos].AgendServ = response.data.AgendServ;
            this.dadosDoServico.AgendServMotorista = response.data.AgendServMotorista;
            this.listaComponente.items[pos].AgendServMotorista = response.data.AgendServMotorista;
            this.listaComponente.items[pos].AgendServItens = response.data.AgendServItens;
            this.listaComponente.items[pos].AgendServItemMerc = response.data.AgendServItemMerc;
            this.listaComponente.items[pos].listaAnexos = Array.from(response.data.AgendServAnexos);
            this.listaComponente.items[pos].UsuarioId = response.data.UsuarioId;
            this.listaComponente.items[pos].ApenasVeiculoMotorista = response.data.ApenasVeiculoMotorista;
           
            this.listaComponente.items[pos].blNumero = response.data.AgendServ.NumeroBl;
            this.listaComponente.items[pos].blSelecionado = response.data.AgendServ.BlId;

            this.tipoSelecionado = {value: response.data.AgendServ.AgendTipoServId, label: response.data.AgendServ.DscTipoServ, RefTipoServ: response.data.AgendServ.RefTipoServ} ;

            this.montarNotasFiscaisEdicaoMultiplos(pos);
            this.montarContainersEdicaoMultiplos(pos);
            this.montarNCMsEdicaoMultiplos(pos);

            if (this.listaComponente.items[pos].blNumero)
                this.montaDadosPorBlEdicaoMultiplos(this.listaComponente.items[pos].blNumero, pos);

            if(response.data.AgendServ.EhClienteEstrangeiro){
                this.listaComponente.items[pos].clienteEstrangeiroSelecionado = {value: response.data.AgendServ.ParcIdDespa, label: response.data.AgendServ.RazaoSocialDespa};
                this.listaComponente.items[pos].clienteEstrangeiroSelecionadoData = response.data.AgendServ.ParcIdDespa + "-" + response.data.AgendServ.EstabIdDespa;
            }

            if(response.data.AgendServ.EhCobrarDeEstrangeiro){
                this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionado = {value: response.data.AgendServ.ParcIdCobrar, label: response.data.AgendServ.RazaoSocialCobrar};
                this.listaComponente.items[pos].cobrarDeEstrangeiroSelecionadoData = response.data.AgendServ.ParcIdCobrar + "-" + response.data.AgendServ.EstabIdCobrar;
            }

            this.listaComponente.items[pos].UsuarioIdTecon = response.data.UsuarioIdTecon;
            this.grupoSelecionado = { label: response.data.AgendServ.DscGrupo };

            this.apenasVeiculo(id);

            this.onChangeTipo({value: response.data.AgendServ.AgendTipoServId, label: response.data.AgendServ.DscTipoServ, RefTipoServ: response.data.AgendServ.RefTipoServ}); // TODO Remover
            // this.onChangeTipoMultiplos({value: response.data.AgendServ.AgendTipoServId, label: response.data.AgendServ.DscTipoServ, RefTipoServ: response.data.AgendServ.RefTipoServ}); // TODO Remover
            this.onBlurMotoristaCNHMultiplos(pos);
            this.carregaTipoConsolidado(pos)
        });
    };

    carregaTipoConsolidado = async (pos) => {
       await this.service.VerificaDadosBlConsolidado(this.listaComponente.items[pos].blNumero).then((response) => {  
            if (response.data == "Nconsolidado") {
                this.listaComponente.items[pos].tipoDado = "Nconsolidado";
            } else {
                this.listaComponente.items[pos].tipoDado = "consolidado";
            }
        })
    }

    montarNotasFiscaisEdicaoMultiplos = (pos) => {
        this.listaComponente.items[pos].AgendServItens.map(cntr => {
            if (cntr.NotasFiscais)
                cntr.NotasFiscais.map(nota => {
                    nota.value = nota.ProtocoloInfDocId;
                    nota.label = `${nota.NumeroNota} ${!this.listaComponente.items[pos].AgendServ.FlgComboio==="S" ? `- Volume ${nota.QtdVolume}`: ""}`;
                });
        });
    };

    montarContainersEdicaoMultiplos  = (pos) => {
            this.listaComponente.items[pos].todosContainersMarcados = true;
            this.listaComponente.items[pos].containers = [];
            this.listaComponente.items[pos].AgendServItens.map(cntr => this.listaComponente.items[pos].containers.push({
                Id: cntr.Id,
                AgendServId: cntr.AgendServId,
                IndStatus: cntr.IndStatus,
                UnitId: cntr.UnitId,
                Volumes: cntr.Volumes,
                CodCntr: cntr.CodCntr,
                IndExcluido: cntr.IndExcluido,
                NotasFiscais: cntr.NotasFiscais,
                notasContainer: false,
                marcado: true,
                Excluir: false,
            }));
        
    };

    montarNCMsEdicaoMultiplos = (pos) => {
        this.listaComponente.items[pos].todosNCMsMarcados = true;
        this.listaComponente.items[pos].ncms = [];
        this.listaComponente.items[pos].AgendServItemMerc.map(ncm =>  this.listaComponente.items[pos].ncms.push({
            AgendServId: ncm.AgendServId,
            AgendServItemId: ncm.AgendServItemId,
            Excluir: false,
            Id: ncm.Id,
            MercId: ncm.MercId.toString(),
            marcado: true
        }));
    };

    montaDadosPorBlEdicaoMultiplos = (bl, pos) => {
        this.buscarDadosBlMultiplosEdicao(bl, pos);
        this.verificarBlMultiplosEdicao(bl, pos);
        this.carregarContainersPorBlMultiplosEdicao(bl, pos);
        this.carregarNcmPorBlMultiplosEdicao(bl, pos);
        this.carregarItensNotaFiscalPorBlMultiplosEdicao(bl, pos);
    };

    verificarBlMultiplosEdicao = async (blId, pos) => {
        this.listaComponente.items[pos].blValido = true;
        await this.service.validarBlConsolidado(blId,this.tipoSelecionado.value).then(response => {
            this.listaComponente.items[pos].blValido = response.data;
        }).catch(error => {
            console.log(error);
        });
    };

    buscarDadosBlMultiplosEdicao = async (blId, pos) => {
        this.listaComponente.items[pos].AgendServ.RazaoSocialCobrar = "";
        this.listaComponente.items[pos].AgendServ.CnpjCobrar = "";
        this.listaComponente.items[pos].AgendServ.BlId = "";
        await this.service.CarregarDadosBlMultiplos(blId).then(response => {
            if (response.status ===404)
            this.listaComponente.items[pos].blNumeroMsg = response.data
            else
        
            this.listaComponente.items[pos].blNumeroMsg = "";

            this.listaComponente.items[pos].AgendServ.RazaoSocialCobrar = response.data.RazaoSocialCliente;
            this.stringTeste = response.data.RazaoSocialCliente;
            this.listaComponente.items[pos].AgendServ.CnpjCobrar = response.data.CnpjCliente;
            this.listaComponente.items[pos].AgendServ.BlId = response.data.BlId;
            //Comentario para atualizar arquivo. Sumiu do develop.
        });
    };

    carregarContainersPorBlMultiplosEdicao = async (blId, pos) => {
        if (!this.isEditar) this.listaComponente.items[pos].containers = false;
        this.listaComponente.items[pos].loadingContainers = true;
            await this.service.ListarContainersPorBlConsolidado(blId).then(response => {
                if(response && response.data) {
                    this.listaComponente.items[pos].loadingContainers = false;
                    if (!this.isEditar) {
                        this.listaComponente.items[pos].containers = [];
                        response.data.map((cntr) => this.listaComponente.items[pos].containers.push(this.novoContainer(cntr)));
                    } else {
                        response.data.map((cntrNovo) => {
                            let achou = this.listaComponente.items[pos].containers.find(cntr => cntrNovo.CodCntr === cntr.CodCntr);
                            if (!achou) {
                                this.listaComponente.items[pos].containers.push(this.novoContainer(cntrNovo));
                                this.listaComponente.items[pos].todosContainersMarcados = false;
                            }
                        });
                    }
                }
            });
    };
    
    carregarNcmPorBlMultiplosEdicao = async (blId, pos) => {
        if (!this.isEditar)
        this.listaComponente.items[pos].ncms = false;
        this.listaComponente.items[pos].loadingNCMs = true;
        await this.service.ListarNcmPorBlConsolidado(blId).then(response => { // "Id", "Ncm"
            if (response && response.data) {
                this.listaComponente.items[pos].loadingNCMs = false;
                if (! this.isEditar) {
                    this.listaComponente.items[pos].ncms = [];
                    response.data.map(n =>  this.listaComponente.items[pos].ncms.push(this.novoNcm(n)));
                } else {
                    response.data.map((ncmNovo) => {
                        let achou =  this.listaComponente.items[pos].ncms.find(ncm => ncm.MercId === ncmNovo.Ncm);
                        if (!achou) {
                            this.listaComponente.items[pos].ncms.push(this.novoNcm(ncmNovo, achou));
                            this.listaComponente.items[pos].todosNCMsMarcados = false;
                        }
                    });
                }
            }
        });
    };

    carregarItensNotaFiscalPorBlMultiplosEdicao = async (NumBl, pos) => {
        this.listaComponente.items[pos].notasFiscal = [];
        const flagComboio = this.listaComponente.items[pos].AgendServ.FlgComboio==='S';
        await this.service.ListarNotaFiscalPorBlConsolidado(NumBl, flagComboio).then(response => {
            response.data.map(nota => this.listaComponente.items[pos].notasFiscal.push(
                {
                    value: nota.ProtocoloInfDocId,
                    label: `${nota.NumNota} ${ !flagComboio ? `- Volume  ${nota.Volume}` :""}`,
                    Id: 0,
                    AgendServItemId: (!this.listaComponente.items[pos].editar) ? 0 : this.listaComponente.items[pos].AgendServ.Id,
                    ProtocoloInfDocId: nota.IdProtocoloInfDoc,
                    NumeroNota: nota.NumNota,
                    QtdVolume: nota.Volume,
                    Excluir: false
                }
            ));
            if (this.isEditar) this.montarNotasFiscaisContainersEdicaoMultiplos(pos);
        });
    };

    onBlurMotoristaCNHMultiplos = (pos) => {
        
        this.motoristaBloqueado = true;
        this.atualiza=false;
        const cnh = this.listaComponente.items[pos].AgendServMotorista.Cnh;
        // this.dadosDoServico.AgendServMotorista = Object.assign({}, this.service.sample.AgendServMotorista);
        this.dadosDoServico.AgendServMotorista.CategCnh = "";
        this.dadosDoServico.AgendServMotorista.Cpf = 0;
        this.dadosDoServico.AgendServMotorista.CpfString = "";
        this.dadosDoServico.AgendServMotorista.Identidade = 0;
        this.dadosDoServico.AgendServMotorista.IdentidadeString = "";
        this.dadosDoServico.AgendServMotorista.OrgEmissId = null;
        this.dadosDoServico.AgendServMotorista.Nome = "";
        this.dadosDoServico.AgendServMotorista.Id = 0;
        this.categoriaSelecionada = false;
        this.orgaoExpedidorSelecionado = false;

        this.bloqueiaCategCnh = false;
        this.bloqueiaNomeMotorista = false;
        this.bloqueiaCpfMotorista = false;
        this.bloqueiaIdentidadeMotorista = false;
        this.bloqueiaOrgEmissId = false;

        if (cnh>0) {
            this.atualiza=true;
            this.service.carregarMotoristaPorCnh(cnh).then(response => {
                this.atualiza=false;
                if (response.data) {
                    this.dadosDoServico.AgendServMotorista.CategCnh = response.data.CategCnh;
                    this.dadosDoServico.AgendServMotorista.Cpf = response.data.Cpf;
                    this.dadosDoServico.AgendServMotorista.CpfString = response.data.Cpf;
                    this.dadosDoServico.AgendServMotorista.Identidade = response.data.Identidade;
                    this.dadosDoServico.AgendServMotorista.IdentidadeString = response.data.Identidade;
                    this.dadosDoServico.AgendServMotorista.OrgEmissId = response.data.OrgEmissId;
                    this.dadosDoServico.AgendServMotorista.Nome = response.data.Nome;
                    this.dadosDoServico.AgendServMotorista.Id = response.data.Id;
                    this.categoriaSelecionada = { label: response.data.CategCnh };
                    this.dadosDoServico.AgendServMotorista.Cnh = cnh;
                    this.dadosDoServico.AgendServMotorista.CnhString = cnh.toString();

                    this.bloqueiaCategCnh =             this.dadosDoServico.AgendServMotorista.CategCnh &&
                                                        this.dadosDoServico.AgendServMotorista.CategCnh.length > 0;
                    this.bloqueiaNomeMotorista =        this.dadosDoServico.AgendServMotorista.Nome &&
                                                        this.dadosDoServico.AgendServMotorista.Nome.length > 0;
                    this.bloqueiaCpfMotorista =         this.dadosDoServico.AgendServMotorista.Cpf > 0;
                    this.bloqueiaIdentidadeMotorista =  this.dadosDoServico.AgendServMotorista.Identidade > 0;
                    this.bloqueiaOrgEmissId =           this.dadosDoServico.AgendServMotorista.OrgEmissId > 0 ;

                    if (response.data.OrgEmissId && this.orgaosExpedidores)
                        this.orgaoExpedidorSelecionado = this.orgaosExpedidores.find(org => org.value === response.data.OrgEmissId)
                    } else {
                        this.motoristaBloqueado = false;
                        this.dadosDoServico.AgendServMotorista.Cnh = cnh;
                        this.dadosDoServico.AgendServMotorista.CnhString = cnh.toString();
                    }
                setTimeout(function() {
                    this.atualiza = true;
                }.bind(this), 1)
            })
        } else {
            setTimeout(function() {
                this.atualiza = true;
            }.bind(this), 1)
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/agendamentoservicos/cadastrar/stores/AgServicosCadastrarStore.js